/* eslint-disable */
/* prettier-ignore */

/**
 * This file is auto-generated with openapi2ts (@mittwald/openapi-to-typescript)
 */

import { KyClient } from "@mittwald/api-client/dist/http/KyClient.js";
import { Client } from "@mittwald/api-client/dist/http/Client.js";
import { RequestFunction } from "@mittwald/api-client/dist/OperationDescriptor.js";
import { OperationDescriptor } from "@mittwald/api-client/dist/OperationDescriptor.js";

/**
 * ====================================
 * Types
 * ====================================
 */
export declare module MittwaldApiV1 {
  namespace Paths {
    namespace Authentication_Tokens {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.ApplicationToken[];
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody =
            MittwaldApiV1.Components.Schemas.ApplicationTokenInput;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.ApplicationTokenResponse;
            }
          }
        }
      }
    }

    namespace Authentication_Accesstoken {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Token;
            }
          }
        }
      }
    }

    namespace Authentication_Tokens_Uuid {
      namespace Delete {
        namespace Parameters {
          interface Path {
            uuid: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }
        }
      }
    }

    namespace Authentication_Self {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                name: string;
                type: "CUS" | "ACC" | "FTP" | "DB" | "MAIL";
                createdAt: number;
              }
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Account;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }

      namespace Patch {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };

          interface RequestBody {
            name?: string;
            active?: boolean;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                msg: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Notifications {
      namespace Get {
        namespace Parameters {
          interface Query {
            countOnly?: boolean;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                notifications: MittwaldApiV1.Components.Schemas.Notification[];
                unreadCount: number;
              }
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          type Header = {};
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Resellers_ResellerIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            resellerIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Reseller;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Databasetypes {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.DatabaseType[];
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Domains {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          interface Query {
            limit?: number;
            offset?: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Domain[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody =
            MittwaldApiV1.Components.Schemas.DomainRegistration;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Domain[];
            }
          }

          namespace $400 {
            namespace Content {}
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Domainsproxies {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.DomainProxy[];
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Domains_DomainIdentifier {
      namespace Delete {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
            domainIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {}
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Domains_DomainIdentifier_Authcode {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
            domainIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.DomainAuthCode;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
            domainIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Subdomain[];
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
            domainIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody =
            MittwaldApiV1.Components.Schemas.SubdomainCreationBody[];
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Subdomain[];
            }
          }

          namespace $400 {
            namespace Content {}
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
            domainIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {}
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains_SubdomainIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
            domainIdentifier: string;
            subdomainIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Subdomain;
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Mailaddresses {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          interface Query {
            limit?: number;
            offset?: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.MailAddress[];
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Software {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Software[];
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Installations {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          interface Query {
            installPath?: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.SoftwareInstallation[];
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Installations_Actions_Update_Php {
      namespace Post {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };

          interface RequestBody {
            version: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                msg?: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              interface Application_Json {
                msg?: string;
              }
            }
          }

          namespace $402 {
            namespace Content {
              interface Application_Json {
                msg?: string;
              }
            }
          }

          namespace $404 {
            namespace Content {
              interface Application_Json {
                msg?: string;
              }
            }
          }
        }
      }
    }

    namespace Installations_InstallationIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            installationIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.SoftwareInstallation;
            }
          }
        }
      }
    }

    namespace Installations_InstallationIdentifier_Extensions {
      namespace Get {
        namespace Parameters {
          interface Path {
            installationIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.SoftwareExtension[];
            }
          }
        }
      }
    }

    namespace Customer {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Customer;
            }
          }
        }
      }
    }

    namespace Customers_Self {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                customerNumber: number;
              }
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Customer;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Contractpartner {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerPartner;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.UpdateContact;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerPartner;
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Contactperson {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerPartner;
            }
          }

          namespace $301 {
            interface Headers {
              Location?: string;
            }

            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody =
            MittwaldApiV1.Components.Schemas.ContactUpdateRequest;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerPartner;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Paymentsettings {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerPaymentSettings;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody =
            MittwaldApiV1.Components.Schemas.CustomerPaymentSettings;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerPaymentSettings;
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Billingrecipient {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerPartner;
            }
          }

          namespace $301 {
            interface Headers {
              Location?: string;
            }

            namespace Content {}
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.UpdateContact;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerPartner;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Billingsettings {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerBillingSettings;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody =
            MittwaldApiV1.Components.Schemas.CustomerBillingSettings;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.CustomerBillingSettings;
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Invoices {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Invoice[];
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Accounts {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          interface Query {
            advised?: boolean;
            owned?: boolean;
            fields?: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Account[];
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Benefits_Benefit {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
            benefit: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Benefit[];
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Contracts {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Contract[];
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Cancelledcontracts {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Contract[];
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Dsgvocontractstatus {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                signed: boolean;
                iframeUrl?: string;
              }
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Settings {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                customerNumber: number;
                language: string;
              }
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };

          interface RequestBody {
            language: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                customerNumber: number;
                language: string;
              }
            }
          }
        }
      }
    }

    namespace Invoices_InvoiceNumber {
      namespace Get {
        namespace Parameters {
          interface Path {
            invoiceNumber: number;
          }

          interface Header {
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Invoice;
            }
          }
        }
      }
    }

    namespace Invoices_InvoiceNumber_Paymentreceipts {
      namespace Get {
        namespace Parameters {
          interface Path {
            invoiceNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.PaymentReceipt[];
            }
          }
        }
      }
    }

    namespace Offers {
      namespace Post {
        namespace Parameters {
          type Header = {};

          type RequestBody = MittwaldApiV1.Components.Schemas.OfferRequest;
        }

        namespace Responses {
          namespace $202 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Orders_PreUpgradeCheck_AccountIdentifier_ArticleNumber {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
            articleNumber: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.OrderPreUpgradeCheck;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $401 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Orders_Partnerprogram {
      namespace Post {
        namespace Parameters {
          type Header = {};

          type RequestBody =
            MittwaldApiV1.Components.Schemas.PartnerHostingOrderRequest;
        }

        namespace Responses {
          namespace $202 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Orders_Partnerbox {
      namespace Post {
        namespace Parameters {
          type Header = {};

          type RequestBody =
            MittwaldApiV1.Components.Schemas.PartnerHostingOrderRequest;
        }

        namespace Responses {
          namespace $202 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Articles {
      namespace Get {
        namespace Parameters {
          interface Query {
            fields?: string;
            limit?: number;
            offset?: number;
            articles?: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Article[];
            }
          }
        }
      }
    }

    namespace Articles_ArticleNumber {
      namespace Get {
        namespace Parameters {
          interface Path {
            articleNumber: string;
          }

          interface Query {
            fields?: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Article;
            }
          }
        }
      }
    }

    namespace Articles_ArticleNumber_Cross_Selling {
      namespace Get {
        namespace Parameters {
          interface Path {
            articleNumber: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.ArticleOption[];
            }
          }
        }
      }
    }

    namespace Articles_ArticleNumber_Upgrades {
      namespace Get {
        namespace Parameters {
          interface Path {
            articleNumber: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.ArticleUpgradeOption[];
            }
          }
        }
      }
    }

    namespace Carts {
      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Cart;
            }
          }
        }
      }
    }

    namespace Carts_CartIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Cart;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Cart;
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Cart;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Items {
      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Cart;
            }
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Items_ItemIdentifier {
      namespace Delete {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
            itemIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Cart;
            }
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Domains {
      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Cart;
            }
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Actions_Checkout {
      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Actions_Offer {
      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Actions_Share {
      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Cart;
            }
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Actions_Recommend {
      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Recommendation;
            }
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Actions_Recommendation_Verify {
      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Actions_Requestverification {
      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }
        }
      }
    }

    namespace Carts_CartIdentifier_Actions_Verify {
      namespace Post {
        namespace Parameters {
          interface Path {
            cartIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }
        }
      }
    }

    namespace Domains_DomainIdentifier_Actions_Check {
      namespace Post {
        namespace Parameters {
          interface Path {
            domainIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }

          namespace $410 {
            namespace Content {}
          }
        }
      }
    }

    namespace Topleveldomains {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.TopLevelDomain[];
            }
          }
        }
      }
    }

    namespace Topleveldomains_TopLevelDomainIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            topLevelDomainIdentifier: string;
          }

          interface Query {
            fields?: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.TopLevelDomain;
            }
          }
        }
      }
    }

    namespace Promotioncodes_PromotionCode {
      namespace Get {
        namespace Parameters {
          interface Path {
            promotionCode: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }
        }
      }
    }

    namespace Promotioncodes_PromotionCode_Actions_Validate {
      namespace Post {
        namespace Parameters {
          interface Path {
            promotionCode: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {}
          }
        }
      }
    }

    namespace Virt_Guestoperatingsystems {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GuestOperatingSystem;
            }
          }
        }
      }
    }

    namespace Bankdata_Actions_Convert {
      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.BankData;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {}
            }
          }

          namespace $400 {
            namespace Content {}
          }
        }
      }
    }

    namespace Webhooks {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Webhook[];
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.Webhook;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Webhook;
            }
          }
        }
      }
    }

    namespace Webhooks_WebhookIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            webhookIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Webhook;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            webhookIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.Webhook;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Webhook;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            webhookIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Cancellations {
      namespace Post {
        namespace Parameters {
          type Header = {};

          type RequestBody =
            MittwaldApiV1.Components.Schemas.CancellationRequest;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Cancellations_CancellationIdentifier_Actions_Confirmationmail {
      namespace Post {
        namespace Parameters {
          interface Path {
            cancellationIdentifier: number;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $202 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {}
          }

          namespace $500 {
            namespace Content {}
          }
        }
      }
    }

    namespace Gdpr_Pdfs {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.Gdprpdf[];
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody =
            MittwaldApiV1.Components.Schemas.UploadGdprpdfRequest;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Gdprpdf;
            }
          }

          namespace $500 {
            namespace Content {}
          }
        }
      }
    }

    namespace Gdpr_Pdfs_PdfIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            pdfIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Gdprpdf;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            pdfIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Gdpr_Pdfs_PdfIdentifier_Actions_Download {
      namespace Post {
        namespace Parameters {
          interface Path {
            pdfIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Gdpr_Contract_Presets {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprContractPreset[];
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody =
            MittwaldApiV1.Components.Schemas.GdprContractPreset;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprContractPreset;
            }
          }

          namespace $500 {
            namespace Content {}
          }
        }
      }
    }

    namespace Gdpr_Contract_Presets_ContractPresetIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            contractPresetIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprContractPreset;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Gdpr_Contracts {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprContract[];
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody =
            MittwaldApiV1.Components.Schemas.CreateGdprContractRequest;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprContract;
            }
          }

          namespace $500 {
            namespace Content {}
          }
        }
      }
    }

    namespace Gdpr_Contracts_ContractIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            contractIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprContract;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            contractIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $409 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Gdpr_Contracts_ContractIdentifier_Actions_Pdf {
      namespace Post {
        namespace Parameters {
          interface Path {
            contractIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Gdpr_Contracts_ContractIdentifier_Actions_Mail {
      namespace Post {
        namespace Parameters {
          interface Path {
            contractIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Gdpr_Contracts_ContractIdentifier_Actions_Accept {
      namespace Post {
        namespace Parameters {
          interface Path {
            contractIdentifier: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Gdpr_Contacts {
      namespace Get {
        namespace Parameters {
          interface Query {
            type?: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprContact[];
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.GdprContact;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprContact;
            }
          }

          namespace $500 {
            namespace Content {}
          }
        }
      }
    }

    namespace Gdpr_Contacts_ContactIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            contactIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprContact;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Gdpr_Toms {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.GdprTom[];
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.GdprTom;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.GdprTom;
            }
          }

          namespace $500 {
            namespace Content {}
          }
        }
      }
    }

    namespace Gdpr_Toms_TomIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            tomIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.GdprTom;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Tickets {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          interface Query {
            sortDirection?: "ASC" | "DESC";
            status?:
              | "open"
              | "in-progress"
              | "feedback"
              | "information"
              | "answered"
              | "done";
            summaryOnly?: boolean;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Ticket[];
            }
          }
        }
      }
    }

    namespace Tickets {
      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.TicketInput;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Ticket;
            }
          }
        }
      }
    }

    namespace Tickets_TicketIdentifier {
      namespace Get {
        namespace Parameters {
          interface Path {
            ticketIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Ticket;
            }
          }
        }
      }
    }

    namespace Tickets_TicketIdentifier_Answers {
      namespace Get {
        namespace Parameters {
          interface Path {
            ticketIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.TicketAnswer[];
            }
          }
        }
      }

      namespace Post {
        namespace Parameters {
          interface Path {
            ticketIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.TicketAnswerInput;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.TicketAnswer;
            }
          }
        }
      }
    }

    namespace Tickets_TicketIdentifier_Actions_Close {
      namespace Post {
        namespace Parameters {
          interface Path {
            ticketIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.TicketAnswer;
            }
          }
        }
      }
    }

    namespace Ticket_Categories {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.TicketCategory[];
            }
          }
        }
      }
    }

    namespace Daemoncloud_Allowed {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.AllowedFileTypes;
            }
          }
        }
      }
    }

    namespace Daemoncloud_Files {
      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.FileMeta;
            }
          }
        }
      }
    }

    namespace Daemoncloud_Files_FileId {
      namespace Get {
        namespace Parameters {
          interface Path {
            fileId: string;
          }

          type Header = {
            Accept?: "text/plain";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Text_Plain = string;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          interface Path {
            fileId: string;
          }

          type Header = {};
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }
        }
      }
    }

    namespace Daemoncloud_Files_FileId_Details {
      namespace Get {
        namespace Parameters {
          interface Path {
            fileId: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.FileMeta;
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Stats_Visitors {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.VisitorStatistics;
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Stats {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.StorageStatistics;
            }
          }
        }
      }
    }

    namespace PhoneVerification_Customernumber {
      namespace Get {
        namespace Parameters {
          interface Path {
            customernumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.VerificationCode;
            }
          }
        }
      }
    }

    namespace Menu {
      namespace Get {
        namespace Parameters {
          interface Query {
            forceMittwaldVersion?: boolean;
            skipCache?: boolean;
            onlyRootLevel?: boolean;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.MainMenu;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace MenuMeta {
      namespace Get {
        namespace Parameters {
          interface Query {
            skipCache?: boolean;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.MainMeta;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Search {
      namespace Get {
        namespace Parameters {
          interface Query {
            needle: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.SearchResult;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_DomainOverview {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.DomainOverviewItem[];
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Dns {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.DnsOverviewItem[];
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Ip_Addresses {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.AccountIpAddress[];
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Dns_DomainIdentifier {
      namespace Put {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
            domainIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.DnsRecordRequest;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.DnsUpdateResponse;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.DnsValidationErrorResponse;
            }
          }
        }
      }
    }

    namespace Flagging_Flags_FlagId {
      namespace Get {
        namespace Parameters {
          interface Path {
            flagId: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                signed?: string;
              }
            }
          }
        }
      }
    }

    namespace Accounts_Account_Actions_Change_Password {
      namespace Post {
        namespace Parameters {
          interface Path {
            account: string;
          }

          type Header = {};

          type RequestBody =
            MittwaldApiV1.Components.Schemas.PasswordChangeRequest;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              interface Application_Json {
                errors?: string[];
              }
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Actions_Change_Password {
      namespace Post {
        namespace Parameters {
          interface Path {
            customerNumber: string;
          }

          type Header = {};

          type RequestBody =
            MittwaldApiV1.Components.Schemas.PasswordChangeRequest;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              interface Application_Json {
                errors?: string[];
              }
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }
        }
      }
    }

    namespace Mfa_Actions_Init {
      namespace Post {
        namespace Parameters {
          interface Header {
            "X-JWT"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {}
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                barcode: string;
                url: string;
              }
            }
          }
        }
      }
    }

    namespace Mfa_Actions_Confirm {
      namespace Post {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          interface RequestBody {
            multiFactorCode: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                recoveryCodesList: string[];
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.ValidationError;
            }
          }
        }
      }
    }

    namespace Mfa {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                initialized: boolean;
                confirmed: boolean;
              }
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };

          interface RequestBody {
            multiFactorCode: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                recoveryCodesList: string[];
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.ValidationError;
            }
          }
        }
      }

      namespace Delete {
        namespace Parameters {
          type Header = {};

          interface RequestBody {
            multiFactorCode: string;
          }
        }

        namespace Responses {
          namespace $204 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.ValidationError;
            }
          }
        }
      }
    }

    namespace Mfa_Secret {
      namespace Get {
        namespace Parameters {
          interface Query {
            multiFactorCode?: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                barcode: string;
                url: string;
              }
            }
          }
        }
      }
    }

    namespace Verify {
      namespace Post {
        namespace Parameters {
          type Header = {};

          type RequestBody = MittwaldApiV1.Components.Schemas.EncodedJwt;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {}
          }

          namespace $400 {
            namespace Content {}
          }

          namespace $403 {
            namespace Content {}
          }
        }
      }
    }

    namespace Sign {
      namespace Post {
        namespace Parameters {
          interface Header {
            "X-JWT": string;
            Accept?: "application/json" | "application/jwt";
          }

          type RequestBody = MittwaldApiV1.Components.Schemas.Jwt;
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Jwt;

              type Application_Jwt = MittwaldApiV1.Components.Schemas.Jwt;
            }
          }
        }
      }
    }

    namespace Key {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/x-pem-file";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_X_Pem_File =
                MittwaldApiV1.Components.Schemas.PublicKey;
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Is_Show_Feedback {
      namespace Get {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                isShowFeedback: boolean;
                isNotNow: boolean;
              }
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Customers_CustomerNumber_Feedback {
      namespace Post {
        namespace Parameters {
          interface Path {
            customerNumber: number;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.CreateFeedback;
        }

        namespace Responses {
          namespace $201 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $422 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $425 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $429 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Accounts_AccountIdentifier_Blocked_Bots {
      namespace Get {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                blockedBots: MittwaldApiV1.Components.Schemas.BlockedBots;
                isManaged: boolean;
              }
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }

      namespace Put {
        namespace Parameters {
          interface Path {
            accountIdentifier: string;
          }

          type Header = {
            Accept?: "application/json";
          };

          type RequestBody = MittwaldApiV1.Components.Schemas.SetBlockedBots;
        }

        namespace Responses {
          namespace $204 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }

          namespace $404 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $422 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $429 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Message;
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Account_Default_Blocked_Bots {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                defaultBlockedBots: MittwaldApiV1.Components.Schemas.BlockedBots;
              }
            }
          }

          namespace $500 {
            namespace Content {
              type Application_Json = MittwaldApiV1.Components.Schemas.Error;
            }
          }
        }
      }
    }

    namespace Public_Topleveldomains {
      namespace Get {
        namespace Parameters {
          type Header = {
            Accept?: "application/json";
          };
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              type Application_Json =
                MittwaldApiV1.Components.Schemas.PublicTopLevelDomain[];
            }
          }
        }
      }
    }
  }

  namespace Components {
    namespace Schemas {
      interface DnsValidationErrorResponse {
        message: string;
        errors?: string[];
      }

      interface Account {
        uid?: number;
        customerNumber?: number;
        name?: string;
        activateShell?: boolean;
        description: string;
        disabled?: boolean;
        ipAddresses?: MittwaldApiV1.Components.Schemas.IpAddress[];
        status?: "creating" | "updating" | "deleting" | "ready";
      }

      interface AllowedFileTypes {
        mimetypes: string[];
        extensions: string[];
      }

      interface ApplicationToken {
        uuid: string;
        crdate: string;
        description?: string;
      }

      interface ApplicationTokenInput {
        description: string;
      }

      interface ApplicationTokenResponse {
        uuid: string;
        crdate: string;
        token: string;
        description?: string;
      }

      interface Token {
        token: string;
      }

      interface Article {
        articleNumber?: number;
        isOrderable?: boolean;
        price?: {
          default?: {
            net?: number;
            currency?: string;
            setupFee?: number;
            vat?: number;
          };
        };
        description?: {
          title?: string;
          text?: string;
        };
        contract?: {
          contractDuration?: number;
          unit?: {
            key?: string;
            value?: string;
          };
        };
        billing?: {
          billingPeriod?: number;
          allowDurationModification?: boolean;
          unit?: {
            key?: string;
            value?: string;
          };
        };
        commission?: {
          default?: {
            net?: number;
            currency?: string;
            setupFee?: number;
            vat?: number;
          };
        };
        articleGroups?: MittwaldApiV1.Components.Schemas.ArticleGroup[];
        benefits?: {
          server?: {
            hardware?: {
              maxWebspace?: number;
              vCpuCores?: number;
              vCpuUnits?: number;
              vMaxMemory?: number;
              vMaxTraffic?: number;
              memoryLimit?: number;
              maxExecutionTime?: number;
            };
            backup?: {
              backupRange?: number;
            };
            cronJob?: {
              max?: number;
              minInterval?: number;
              customInterval?: boolean;
            };
            ssl?: {
              inclusive?: number;
            };
            ip?: {
              inclusive?: number;
            };
            ftpUser?: {
              max?: number;
            };
            ssh?: {
              active?: boolean;
            };
          };
          domain?: {
            active?: boolean;
            inclusive?: number;
            max?: number;
          };
          subdomain?: {
            max?: number;
          };
          mailAddress?: {
            max?: number;
            maxAutoResponder?: number;
          };
          mailBox?: {
            max?: number;
            maxSize?: number;
            spamDefender?: {
              key?: number;
            };
          };
          database?: {
            mysql?: {
              max?: number;
              externalAccess?: boolean;
            };
          };
          webFtp?: {
            active?: boolean;
          };
          webMail?: {
            active?: boolean;
          };
          dnsEditor?: {
            active?: boolean;
            editorA?: boolean;
            editorCNAME?: boolean;
            editorMX?: boolean;
            editorSRV?: boolean;
            editorTXT?: boolean;
          };
          firewallPlus?: {
            active?: boolean;
          };
          monitoringPlus?: {
            active?: boolean;
          };
          designSwitcher?: {
            active?: boolean;
          };
          versionManager?: {
            active?: boolean;
          };
          template?: {
            max?: number;
          };
          snapshot?: {
            max?: number;
          };
        };
        configurationData?: {
          limits?: {
            max_cores?: number;
            max_documents?: number;
            memory?: number;
          };
        };
        articleOptions?: {
          mainCategory?: {
            subCategory?: MittwaldApiV1.Components.Schemas.ArticleOption[];
          };
        };
        crossSellingArticles?: MittwaldApiV1.Components.Schemas.CrossSellingOption[];
      }

      interface ArticleGroup {
        href?: string;
        title?: string;
      }

      interface ArticleOption {
        default?: boolean;
        price?: {
          default?: {
            net?: number;
            currency?: string;
            setupFee?: number;
            vat?: number;
          };
        };
        article?: MittwaldApiV1.Components.Schemas.Article;
      }

      interface ArticleUpgradeOption {
        targetArticleNumber?: number;
        toolboxProRequired?: boolean;
        description?: string;
      }

      interface AuthenticationResponse {
        token: string;
        expires: string;
      }

      interface BankData {
        bankAccountNumber?: string;
        bankCode?: string;
      }

      interface Benefit {
        benefit?: {
          identifier?: string;
          uid?: number;
        };
        exceedance?: number;
        uid?: number;
        usage?: number;
        value?: number;
      }

      interface Billing {
        vatRegNumber?: string;
      }

      interface Cancellation {
        uid?: number;
        status?: string;
        creationDate?: number;
        cancellationDate?: string;
      }

      interface CancellationRequest {
        contract: number;
        domains?: {
          domain?: string;
          transfer?: boolean;
          transit?: boolean;
          cancellationDate?: number;
        }[];
        message?: string;
        call?: boolean;
        reason?: number;
      }

      interface Cart {
        _id?: string;
        items?: MittwaldApiV1.Components.Schemas.Article[];
        jwt?: string;
        promotionCode?: string;
        newsletter?: boolean;
        offer?: number;
        software?: string;
        os?: string;
        note?: string;
        mysqlVersion?: string;
        databasePartitionPercentage?: number;
        sourceAccount?: string;
        sourceReseller?: string;
        agencyServer?: number;
        stayOnHardware?: boolean;
        testing?: boolean;
        billingPeriod?: number;
        customerBillingPeriod?: number;
        commission?: string;
        isCommissionLocked?: boolean;
        dueDate?: number;
        projectName?: string;
        projectPassword?: string;
        contractPartner?: MittwaldApiV1.Components.Schemas.Contact;
        contactPerson?: MittwaldApiV1.Components.Schemas.Contact;
        billingAddress?: MittwaldApiV1.Components.Schemas.Contact;
        paymentSettings?: MittwaldApiV1.Components.Schemas.PaymentSettings;
      }

      interface CartItem {
        _id: string;
        itemType: string;
        identifier: string;
      }

      interface CartItemInput {
        identifier: string;
        sourceIdentifier?: string;
      }

      interface Contact {
        firstName: string;
        lastName: string;
        title?: string;
        salutation: "Herr" | "Frau" | "Divers";
        street: string;
        houseNumber: string;
        zip: string;
        city: string;
        company?: string;
        emailAddress: string;
        country: string;
        fax?: string;
      }

      type ContactUpdateRequest =
        MittwaldApiV1.Components.Schemas.UpdateContact;

      type ContactWithPhone = MittwaldApiV1.Components.Schemas.Contact & {
        phone: string;
      };

      interface Contract {
        title?: string;
        startDate?: string;
        contractDuration?: string;
      }

      interface Country {
        isoShort: string;
        isoLong: string;
        euMember: boolean;
        name: {
          de: string;
          en: string;
        };
      }

      interface CreateCustomerRequest {
        contractPartner: MittwaldApiV1.Components.Schemas.ContactWithPhone;
        contactPerson?: MittwaldApiV1.Components.Schemas.OptionalContactWithPhone;
        billingAddress?: MittwaldApiV1.Components.Schemas.OptionalContactWithTaxId;
        paymentSettings?: MittwaldApiV1.Components.Schemas.PaymentSettings;
      }

      interface CreateCustomerResponse {
        customerNumber: string;
        password: string;
      }

      interface CreateGdprContractRequest {
        html: string;
        tom: string;
        client: string;
        recipient: string;
        isPartnerContract?: boolean;
      }

      interface CrossSellingOption {
        href?: string;
        articleNumber?: number;
        sorting?: number;
      }

      interface Customer {
        customerNumber: number;
        prospect: boolean;
      }

      interface CustomerAccount {
        name?: string;
        description?: string;
        article?: MittwaldApiV1.Components.Schemas.Article;
        contracts?: MittwaldApiV1.Components.Schemas.Contract[];
      }

      interface CustomerAddress {
        street: string;
        houseNumber: string;
        zip: string;
        city: string;
        country: MittwaldApiV1.Components.Schemas.Country;
      }

      interface CustomerBillingSettings {
        vatID?: string;
        postalInvoices: boolean;
      }

      interface CustomerCategory {
        uid: number;
        name: string;
      }

      interface CustomerContactData {
        telephone: string;
        fax?: string;
        email: string;
      }

      interface CustomerContract {
        uid?: number;
        article?: MittwaldApiV1.Components.Schemas.Article;
        title?: string;
        text?: string;
        sourceUid?: number;
        sourceType?: string;
        creationDate?: number;
        nextPeriodDate?: number;
        billingPeriod?: number;
        cancellation?: MittwaldApiV1.Components.Schemas.Cancellation;
        account?: {
          name?: string;
          description?: string;
          additionalArticles?: MittwaldApiV1.Components.Schemas.Article[];
        };
      }

      interface CustomerPartner {
        firstName: string;
        lastName: string;
        title?: string;
        salutation: string;
        company?: string;
        address: MittwaldApiV1.Components.Schemas.CustomerAddress;
        contact: MittwaldApiV1.Components.Schemas.CustomerContactData;
      }

      interface CustomerPaymentSettings {}

      interface DatabaseType {
        uid?: number;
        type?: string;
        default?: boolean;
      }

      interface Domain {
        name?: string;
        fullname?: string;
        registryStatus?: string;
        tld?: string;
      }

      interface DomainAuthCode {
        "auth-code"?: string;
      }

      interface DomainDeletionRequest {
        transfer?: boolean;
        transit?: boolean;
        cancellationDate?: number;
      }

      interface DomainItem {
        _id: string;
        itemType: string;
        name: string;
        authCode?: string;
        transfer: boolean;
      }

      interface DomainItemInput {
        name: string;
        authCode?: string;
        transfer?: boolean;
      }

      interface DomainNameTransfer {
        authcode?: string;
        authInfoProcedure?: number;
      }

      interface DomainProxy {
        uid?: number;
        domain?: {
          uid?: number;
          name?: string;
        };
        subDomain?: {
          uid?: number;
          name?: string;
        };
        sourceAccount?: {
          uid?: number;
          name?: string;
        };
        destinationAccount?: {
          uid?: number;
          name?: string;
        };
        expireDate?: {
          date?: string;
          timezone_type?: number;
          timezone?: string;
        };
      }

      interface DomainRegistration {
        handles?: MittwaldApiV1.Components.Schemas.Handles;
        sld: string;
        tld: string;
        domainNameTransfer?: MittwaldApiV1.Components.Schemas.DomainNameTransfer;
        external?: boolean;
        target?: string;
      }

      interface Email {
        subject?: string;
        body?: string;
        htmlTemplate?: string;
        templateData?: {};
        senderAddress?: string;
        senderName?: string;
      }

      interface Error {
        message?: string;
      }

      interface FileMeta {
        id: string;
        type: string;
        name: string;
      }

      interface GdprContact {
        name: string;
        street: string;
        houseNumber: string;
        zipCode: string;
        city: string;
        mail: string;
        creationDate?: string;
        type?: string;
      }

      interface GdprContract {
        creationDate?: string;
        tom?: {};
        client?: {};
        recipient?: {};
        html?: string;
        confirmationDate?: string;
        sentDate?: string;
        reminderSentDate?: string;
        isPartnerContract?: boolean;
        contractSigner?: string;
      }

      interface GdprContractPreset {
        name: string;
        description?: string;
        config?: {};
        creationDate?: string;
      }

      interface Gdprpdf {
        name: string;
        creationDate?: string;
      }

      interface GdprTom {
        content?: string;
        creationDate?: string;
      }

      interface GuestOperatingSystem {
        name?: string;
        identifier?: string;
        pleskRequired?: boolean;
        pleskVersion?: number;
      }

      interface Handles {
        owner?: MittwaldApiV1.Components.Schemas.Contact;
        admin?: MittwaldApiV1.Components.Schemas.Contact;
      }

      interface HostingOrderCustomer {
        firstName: string;
        lastName: string;
        title?: string;
        salutation: "Herr" | "Frau" | "Divers";
        street: string;
        houseNumber: string;
        city: string;
        company?: string;
        emailAddress: string;
        phone: string;
        country: string;
      }

      interface Invoice {
        invoiceNumber: number;
        invoicedAt: string;
        netTotal: MittwaldApiV1.Components.Schemas.InvoiceAmount;
        grossTotal: MittwaldApiV1.Components.Schemas.InvoiceAmount;
        items: MittwaldApiV1.Components.Schemas.InvoiceItem[];
      }

      interface InvoiceAmount {
        currency: "EUR";
      }

      interface InvoiceItem {
        title: string;
        text: string;
        netTotal: MittwaldApiV1.Components.Schemas.InvoiceAmount;
        quantity: {
          amount: number;
          unit?: string;
        };
      }

      interface AccountIpAddress {
        address: string;
        type: "SHARED" | "EXCLUSIVE" | "PREMIUM" | "ACCOUNT" | "CUSTOMER";
        version: 4 | 6;
        commonName: string;
      }

      interface IpAddress {
        address?: string;
        scope?: "internal" | "external";
        version?: number;
        type?: string;
        relatedCertificateCommonName?: string;
      }

      interface MailAck {
        msg?: string;
        recipients?: string[];
      }

      interface MailAddress {
        uid?: number;
        fullName?: string;
      }

      interface Message {
        message?: string;
      }

      interface OfferRequest {
        recipient: MittwaldApiV1.Components.Schemas.OfferRequestRecipient;
        articles: MittwaldApiV1.Components.Schemas.OfferRequestArticles;
        isTechnicalAdminForRecipient?: boolean;
      }

      interface OfferRequestArticle {
        articleNumber: number;
      }

      interface OfferRequestArticles {
        main: MittwaldApiV1.Components.Schemas.OfferRequestArticle;
        additional?: MittwaldApiV1.Components.Schemas.OfferRequestArticle[];
      }

      interface OfferRequestRecipient {
        firstName: string;
        lastName: string;
        title?: string;
        salutation: "Herr" | "Frau" | "Divers";
        street: string;
        houseNumber: string;
        city: string;
        company?: string;
        emailAddress: string;
        phone: string;
        country: string;
      }

      interface OptionalContact {}

      interface OptionalContactWithPhone {}

      type OptionalContactWithTaxId = {
        vat?: string;
      } & MittwaldApiV1.Components.Schemas.OptionalContact;

      interface OrderPreUpgradeCheck {
        ipChanges?: boolean;
      }

      interface PartnerHostingOrderRequest {
        customer?: MittwaldApiV1.Components.Schemas.HostingOrderCustomer;
        billing?: MittwaldApiV1.Components.Schemas.Billing;
      }

      interface PaymentReceipt {
        recordedAt: string;
        amount: MittwaldApiV1.Components.Schemas.InvoiceAmount;
        kind: {
          description: string;
        };
      }

      interface PaymentSettings {}

      interface Recommendation {
        id: string;
        pinCode: number;
        expireDate: string;
      }

      interface Reseller {
        uid?: number;
        name?: string;
        customerNumber?: number;
      }

      interface ShopTestAgencyOrderRequest {
        customer: MittwaldApiV1.Components.Schemas.TestHostingOrderCustomer;
        isRegisteredForNewsletter?: boolean;
      }

      interface Software {
        identifier: string;
        name?: string;
        uid?: number;
        category?: {
          name?: string;
          uid?: number;
        };
      }

      interface SoftwareExtension {
        uid?: number;
        key?: string;
        name?: string;
        version?: string;
      }

      interface SoftwareInstallation {
        uid?: number;
        software?: {
          uid?: number;
          identifier?: string;
          name?: string;
        };
        version?: {
          uid?: number;
          number?: string;
        };
        installPath?: string;
        frontendUrl?: string;
        backendUrl?: string;
        documentRoot?: string;
        status?: "creating" | "updating" | "deleting" | "ready";
        database?: {
          uid?: number;
          name?: string;
        };
      }

      interface StorageStatistics {
        accounts: {
          details: {
            backups: MittwaldApiV1.Components.Schemas.StorageStatisticsItemList;
            dbspace: MittwaldApiV1.Components.Schemas.StorageStatisticsItemList;
            mail: MittwaldApiV1.Components.Schemas.StorageStatisticsItemList;
            snapshot: MittwaldApiV1.Components.Schemas.StorageStatisticsItemList;
            system: MittwaldApiV1.Components.Schemas.StorageStatisticsItemList;
            template: MittwaldApiV1.Components.Schemas.StorageStatisticsItemList;
            webspace: MittwaldApiV1.Components.Schemas.StorageStatisticsItemList;
          };
          limit: number;
          name: string;
          percent: number;
          summary: number;
        }[];
        meta?: {
          limit: number;
          percent: number;
          summary: number;
        };
      }

      interface StorageStatisticsItem {
        itemName: string;
        itemSize: number;
        itemUpdatedAt: number;
      }

      interface StorageStatisticsItemList {
        items: MittwaldApiV1.Components.Schemas.StorageStatisticsItem[];
        summary: number;
      }

      interface Subdomain {
        uid?: number;
        fullName?: string;
        target?: string;
        name?: string;
      }

      interface SubdomainCreationBody {
        name: string;
        target?: string;
      }

      interface TestAccountOrderRequest {
        customer: MittwaldApiV1.Components.Schemas.TestHostingOrderCustomer;
        software?: MittwaldApiV1.Components.Schemas.Software;
        isRegisteredForNewsletter?: boolean;
      }

      interface TestAgencyOrderRequest {
        customer: MittwaldApiV1.Components.Schemas.TestHostingOrderCustomer;
        isRegisteredForNewsletter?: boolean;
      }

      interface TestHostingOrderCustomer {
        firstName: string;
        lastName: string;
        title?: string;
        salutation: "Herr" | "Frau" | "Divers";
        street?: string;
        houseNumber?: string;
        city?: string;
        company?: string;
        emailAddress: string;
        phone?: string;
        country: string;
      }

      interface Ticket {
        uid: number;
        subject: string;
        message: string;
        createdAt: string;
        updatedAt: string;
        status: MittwaldApiV1.Components.Schemas.TicketStatus;
        publicStatus: MittwaldApiV1.Components.Schemas.TicketStatus;
        author: {
          name: string;
          email: string;
          telephone: string;
          isMittwaldAuthor: boolean;
        };
        account?: {
          uid: number;
          name: string;
        };
        customer?: {
          customernumber: number;
        };
        answersCount: number;
        files?: string[];
      }

      type TicketStatus =
        | "open"
        | "in-progress"
        | "feedback"
        | "information"
        | "answered"
        | "done";

      interface TicketCategory {
        uid?: number;
        name?: string;
      }

      interface TicketAnswer {
        uid: number;
        message: string;
        createdAt: string;
        author: {
          name: string;
          email: string;
          telephone: string;
          isMittwaldAuthor: boolean;
        };
        files?: string[];
      }

      interface TicketAnswerInput {
        message: string;
        author?: {
          name?: string;
          email?: string;
          telephone?: string;
        };
        customer?: {
          customernumber: number;
        };
        files?: MittwaldApiV1.Components.Schemas.FileMeta[];
      }

      interface TicketInput {
        subject: string;
        message: string;
        author?: {
          name?: string;
          email?: string;
          telephone?: string;
          notify?: boolean;
        };
        account?: {
          name: string;
        };
        customer: {
          customernumber: number;
        };
        files?: MittwaldApiV1.Components.Schemas.FileMeta[];
      }

      interface TopLevelDomain {
        uid?: number;
        name?: string;
        description?: string;
        articleNumber?: number;
        price?: string;
        agencyPrice?: string;
        setupFee?: string;
        isAllowedAsInclusiveDomain?: boolean;
      }

      interface UpdateContact {
        firstName?: string;
        lastName?: string;
        title?: string;
        salutation?: "Herr" | "Frau" | "Divers";
        street?: string;
        houseNumber?: string;
        zip?: string;
        city?: string;
        emailAddress?: string;
        phone?: string;
        fax?: string;
        country?: string;
        vat?: string;
      }

      interface UpgradeCase {
        targetArticleNumber?: number;
        toolboxProRequired?: boolean;
        description?: string;
      }

      interface UploadGdprpdfRequest {
        name: string;
        pdf: string;
      }

      interface CreateFeedback {
        vote?: 1 | 2 | 3 | 4 | 5;
        message?: string;
        notNow?: boolean;
      }

      interface SetBlockedBots {
        blockedBots?: MittwaldApiV1.Components.Schemas.BlockedBots;
      }

      type BlockedBots = string[];

      interface VerificationCode {
        code: string;
      }

      interface VirtualAccount {
        uid: number;
        name: string;
        description: string;
        virtualName: string;
        article: MittwaldApiV1.Components.Schemas.Article;
      }

      interface VirtualAccountInput {
        password: string;
        description: string;
        article: MittwaldApiV1.Components.Schemas.Article;
        virtualName: string;
      }

      type VirtualAccountOutput =
        MittwaldApiV1.Components.Schemas.VirtualAccount & {
          password: string;
        };

      interface VisitorStatistics {
        id?: string;
        last_information_at?: number;
        limit?: {
          article: {
            name: string;
            number: number;
          };
          maximum: number;
          maximum_updated_at?: string;
          usage: number;
          usage_absolute: number;
        };
        name?: string;
        skip_information?: boolean;
        throttling?: {
          enabled: boolean;
        };
        grace_period?: {};
        visitor_information?: {
          daily?: {
            count?: number;
            date?: string;
          }[];
          monthly?: {
            count?: number;
            date?: string;
          }[];
        };
      }

      interface Webhook {
        uid?: string;
        url: string;
        method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
        eventType: "DOMAIN_REGISTRATION_STATUS";
        headers?: {};
        parameters?: MittwaldApiV1.Components.Schemas.WebhookParameter;
      }

      interface WebhookParameter {
        key?: string;
        value?: string;
      }

      interface MenuItemPayload {
        name: string;
        accountUid?: string;
        description: string;
        statusFields?: {
          disabled: boolean;
          devAccount: boolean;
          technicalAdvised: boolean;
          editLock: string | null;
        };
        elementType: string;
        subLevelCount: number;
      }

      interface MainMenu {
        top: MittwaldApiV1.Components.Schemas.MenuItem[];
        left: MittwaldApiV1.Components.Schemas.MenuItem[];
        contract: MittwaldApiV1.Components.Schemas.MenuItem[];
        support: MittwaldApiV1.Components.Schemas.MenuItem[];
      }

      interface MenuItem {
        key: string;
        type: "relative" | "static" | "javascript" | "none";
        value: string;
        urlTarget?: string;
        payload?: MittwaldApiV1.Components.Schemas.MenuItemPayload;
        children?: MittwaldApiV1.Components.Schemas.MenuItem[];
      }

      interface MainMeta {
        errors: MittwaldApiV1.Components.Schemas.MetaItem[];
        warnings: MittwaldApiV1.Components.Schemas.MetaItem[];
      }

      interface MetaItem {
        account: string;
        name: string;
        usagePercent?: number;
        hexCode?: string;
      }

      interface SearchResult {
        accounts?: MittwaldApiV1.Components.Schemas.AccountSearchResult[];
        reseller?: MittwaldApiV1.Components.Schemas.ResellerSearchResult[];
        solr?: MittwaldApiV1.Components.Schemas.SolrSearchResult[];
      }

      interface AccountSearchResult {
        account_uid: number;
        account_name: string;
        account_desc: string;
        dom_list: string;
      }

      interface ResellerSearchResult {
        reseller_uid: number;
        reseller_name: string;
        reseller_desc: string;
      }

      interface SolrSearchResult {
        solr_uid: number;
        solr_name: string;
      }

      interface DomainOverviewItem {
        uid: number;
        _class: string;
        fullname: string;
        domain: string;
        target: string;
        accountUid: number;
        accountName: string;
        useAutodiscover: boolean;
        hasSslCertificate: boolean;
        hasVarnish: boolean;
        isSubDomain: boolean;
        isExternal: boolean;
        isSslReady: boolean;
        isTodoReady: boolean;
        isRegistrarJobOpen: boolean;
        isReady: boolean;
      }

      interface DnsRecord {
        host: string;
        value: string;
        ttl: number;
        priority: number;
      }

      interface DnsOverviewItem {
        uid: number;
        _class: string;
        isSubdomain: boolean;
        isReady: boolean;
        hasSslCertificate: boolean;
        fullName: string;
        domainName: string;
        defaultAccountIp: string;
        defaultDomainIp?: {
          4?: string;
          6?: string;
        };
        records: {
          A: MittwaldApiV1.Components.Schemas.DnsRecord[];
          AAAA: MittwaldApiV1.Components.Schemas.DnsRecord[];
          CNAME: MittwaldApiV1.Components.Schemas.DnsRecord[];
          NS: MittwaldApiV1.Components.Schemas.DnsRecord[];
          MX: MittwaldApiV1.Components.Schemas.DnsRecord[];
          TXT: MittwaldApiV1.Components.Schemas.DnsRecord[];
          SRV: MittwaldApiV1.Components.Schemas.DnsRecord[];
          CAA: MittwaldApiV1.Components.Schemas.DnsRecord[];
        };
      }

      interface DnsRecordRequest {
        mx?: MittwaldApiV1.Components.Schemas.MxRecord;
        target?: MittwaldApiV1.Components.Schemas.TargetRecord;
        ns?: string[];
        txt?: string[];
        srv?: MittwaldApiV1.Components.Schemas.SrvRecord[];
      }

      interface ManualMxRecord {
        priority: number;
        value: string;
      }

      type AutoMxRecordOption = "AUTO" | "NONE";

      type MxRecord =
        | MittwaldApiV1.Components.Schemas.ManualMxRecord[]
        | MittwaldApiV1.Components.Schemas.AutoMxRecordOption;

      type TargetRecord =
        | MittwaldApiV1.Components.Schemas.CName
        | MittwaldApiV1.Components.Schemas.IpRecord;

      type CName = string;

      interface IpRecord {
        a: string;
        aaaa?: string;
      }

      interface SrvRecord {
        service: string;
        protocol: MittwaldApiV1.Components.Schemas.SrvProtocol;
        server: string;
        priority: number;
        weight: number;
        port: number;
      }

      type SrvProtocol = "tcp" | "udp" | "tls";

      interface DnsUpdateResponse {
        message?: string;
      }

      interface BlogArticle {
        title: string;
        timestamp: string;
        description: string;
        images?: MittwaldApiV1.Components.Schemas.BlogArticleImage[];
        link: string;
        identifier: string;
      }

      interface BlogArticleImage {
        url?: string;
        width?: number;
      }

      interface PasswordChangeRequest {
        password: string;
      }

      interface ValidationError {
        message: string;
        type: string;
      }

      interface AuthenticationRequest {
        username: string;
        password: string;
        multiFactorCode?: string;
        ttl?: number;
        providers?: {}[];
        sudo?: boolean;
      }

      interface Jwt {
        sub: string;
        iat: number;
        exp?: number;
        includes?: string[];
      }

      type EncodedJwt = string;

      type PublicKey = string;

      interface Notification {
        uid: number;
        crdate: number;
        read: boolean;
        title: string;
        message: string;
      }

      interface PublicTopLevelDomain {
        uid: number;
        name: string;
        description: string;
        price: string;
        setupFee: string;
        type: string;
      }
    }

    namespace Parameters {}

    namespace Responses {
      type $400 = any;

      type $403 = any;

      type $500 = any;
    }

    namespace RequestBodies {}
  }

  namespace Definitions {}
}

/**
 * ====================================
 * Descriptors
 * ====================================
 */

export const listApplicationTokens: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Authentication_Tokens.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Authentication_Tokens.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/authentication/tokens",
  method: "get",
  operationId: "listApplicationTokens",
};

export const createApplicationToken: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Authentication_Tokens.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Authentication_Tokens.Post.Parameters.Header;
  },
  | { status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Authentication_Tokens.Post.Responses.$201.Content.Application_Json;
    }
> = {
  path: "/authentication/tokens",
  method: "post",
  operationId: "createApplicationToken",
};

export const getAccessToken: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Authentication_Accesstoken.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Authentication_Accesstoken.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/authentication/accesstoken",
  method: "get",
  operationId: "getAccessToken",
};

export const deleteApplicationToken: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Authentication_Tokens_Uuid.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Authentication_Tokens_Uuid.Delete.Parameters.Path;
  },
  | { status: 200 } & {
      content: undefined;
    }
> = {
  path: "/authentication/tokens/{uuid}",
  method: "delete",
  operationId: "deleteApplicationToken",
};

export const getUserName: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Authentication_Self.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Authentication_Self.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/authentication/self",
  method: "get",
  operationId: "getUserName",
};

export const getAccount: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}",
  method: "get",
  operationId: "getAccount",
};

export const updateAccount: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Patch.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Patch.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Patch.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Patch.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Patch.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier.Patch.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}",
  method: "patch",
  operationId: "updateAccount",
};

export const getNotifications: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Notifications.Get.Parameters.Header;

    query: MittwaldApiV1.Paths.Notifications.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Notifications.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Notifications.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/notifications",
  method: "get",
  operationId: "getNotifications",
};

export const deleteNotifications: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Notifications.Delete.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Notifications.Delete.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/notifications",
  method: "delete",
  operationId: "deleteNotifications",
};

export const getReseller: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Resellers_ResellerIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Resellers_ResellerIdentifier.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Resellers_ResellerIdentifier.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Resellers_ResellerIdentifier.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/resellers/{resellerIdentifier}",
  method: "get",
  operationId: "getReseller",
};

export const listDatabaseTypes: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Databasetypes.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Databasetypes.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/databasetypes",
  method: "get",
  operationId: "listDatabaseTypes",
};

export const listDomainsByAccount: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains.Get.Parameters.Path;

    query: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/domains",
  method: "get",
  operationId: "listDomainsByAccount",
};

export const registerNewDomain: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      content: undefined;
    })
> = {
  path: "/accounts/{accountIdentifier}/domains",
  method: "post",
  operationId: "registerNewDomain",
};

export const domainProxyList: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domainsproxies.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domainsproxies.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domainsproxies.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/accounts/{accountIdentifier}/domainsproxies",
  method: "get",
  operationId: "domainProxyList",
};

export const deleteDomain: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      content: undefined;
    })
> = {
  path: "/accounts/{accountIdentifier}/domains/{domainIdentifier}",
  method: "delete",
  operationId: "deleteDomain",
};

export const getDomainAuthCode: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Authcode.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Authcode.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Authcode.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Authcode.Get.Responses.$404.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/domains/{domainIdentifier}/authcode",
  method: "get",
  operationId: "getDomainAuthCode",
};

export const listSubdomainsByDomain: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/accounts/{accountIdentifier}/domains/{domainIdentifier}/subdomains",
  method: "get",
  operationId: "listSubdomainsByDomain",
};

export const createSubdomain: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      content: undefined;
    })
> = {
  path: "/accounts/{accountIdentifier}/domains/{domainIdentifier}/subdomains",
  method: "post",
  operationId: "createSubdomain",
};

export const deleteSubdomain: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains.Delete.Parameters.Path;
  },
  | ({ status: 200 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      content: undefined;
    })
> = {
  path: "/accounts/{accountIdentifier}/domains/{domainIdentifier}/subdomains",
  method: "delete",
  operationId: "deleteSubdomain",
};

export const getSubdomain: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains_SubdomainIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains_SubdomainIdentifier.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Domains_DomainIdentifier_Subdomains_SubdomainIdentifier.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/accounts/{accountIdentifier}/domains/{domainIdentifier}/subdomains/{subdomainIdentifier}",
  method: "get",
  operationId: "getSubdomain",
};

export const listEmailAddressesByAccount: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Mailaddresses.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Mailaddresses.Get.Parameters.Path;

    query: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Mailaddresses.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Mailaddresses.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Mailaddresses.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/mailaddresses",
  method: "get",
  operationId: "listEmailAddressesByAccount",
};

export const listSoftwares: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Software.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Software.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/software",
  method: "get",
  operationId: "listSoftwares",
};

export const listSoftwareInstallationsByAccount: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations.Get.Parameters.Path;

    query: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations.Get.Parameters.Query;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/accounts/{accountIdentifier}/installations",
  method: "get",
  operationId: "listSoftwareInstallationsByAccount",
};

export const updatePhp: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations_Actions_Update_Php.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations_Actions_Update_Php.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations_Actions_Update_Php.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations_Actions_Update_Php.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations_Actions_Update_Php.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 402 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations_Actions_Update_Php.Post.Responses.$402.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Installations_Actions_Update_Php.Post.Responses.$404.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/installations/actions/update-php",
  method: "post",
  operationId: "updatePhp",
};

export const getSoftwareInstallation: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Installations_InstallationIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Installations_InstallationIdentifier.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Installations_InstallationIdentifier.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/installations/{installationIdentifier}",
  method: "get",
  operationId: "getSoftwareInstallation",
};

export const listSoftwareInstallationExtensions: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Installations_InstallationIdentifier_Extensions.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Installations_InstallationIdentifier_Extensions.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Installations_InstallationIdentifier_Extensions.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/installations/{installationIdentifier}/extensions",
  method: "get",
  operationId: "listSoftwareInstallationExtensions",
};

export const getCurrentCustomer: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customer.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customer.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customer",
  method: "get",
  operationId: "getCurrentCustomer",
};

export const getOwnCustomer: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_Self.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_Self.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/self",
  method: "get",
  operationId: "getOwnCustomer",
};

export const getCustomer: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/customers/{customerNumber}",
  method: "get",
  operationId: "getCustomer",
};

export const getCustomerContractPartner: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Contractpartner.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Contractpartner.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Contractpartner.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Contractpartner.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/customers/{customerNumber}/contractpartner",
  method: "get",
  operationId: "getCustomerContractPartner",
};

export const updateCustomerContractPartner: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Customers_CustomerNumber_Contractpartner.Put.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Contractpartner.Put.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Contractpartner.Put.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Contractpartner.Put.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/contractpartner",
  method: "put",
  operationId: "updateCustomerContractPartner",
};

export const getCustomerContactPerson: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 301 } & {
      headers: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Get.Responses.$301.Headers;

      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/customers/{customerNumber}/contactperson",
  method: "get",
  operationId: "getCustomerContactPerson",
};

export const updateCustomerContactPerson: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Put.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Put.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Contactperson.Put.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/customers/{customerNumber}/contactperson",
  method: "put",
  operationId: "updateCustomerContactPerson",
};

export const getCustomerPaymentSettings: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Paymentsettings.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Paymentsettings.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Paymentsettings.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/paymentsettings",
  method: "get",
  operationId: "getCustomerPaymentSettings",
};

export const updateCustomerPaymentSettings: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Customers_CustomerNumber_Paymentsettings.Put.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Paymentsettings.Put.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Paymentsettings.Put.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Paymentsettings.Put.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/paymentsettings",
  method: "put",
  operationId: "updateCustomerPaymentSettings",
};

export const getCustomerBillingRecipient: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 301 } & {
      headers: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Get.Responses.$301.Headers;

      content: undefined;
    })
> = {
  path: "/customers/{customerNumber}/billingrecipient",
  method: "get",
  operationId: "getCustomerBillingRecipient",
};

export const updateCustomerBillingRecipient: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Put.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Put.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Put.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Put.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/billingrecipient",
  method: "put",
  operationId: "updateCustomerBillingRecipient",
};

export const resetCustomerBillingRecipient: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingrecipient.Delete.Parameters.Path;
  },
  | { status: 204 } & {
      content: undefined;
    }
> = {
  path: "/customers/{customerNumber}/billingrecipient",
  method: "delete",
  operationId: "resetCustomerBillingRecipient",
};

export const getCustomerBillingSettings: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingsettings.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingsettings.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingsettings.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/billingsettings",
  method: "get",
  operationId: "getCustomerBillingSettings",
};

export const updateCustomerBillingSettings: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingsettings.Put.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingsettings.Put.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingsettings.Put.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Billingsettings.Put.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/billingsettings",
  method: "put",
  operationId: "updateCustomerBillingSettings",
};

export const listInvoicesByCustomer: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Invoices.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Invoices.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Invoices.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/invoices",
  method: "get",
  operationId: "listInvoicesByCustomer",
};

export const listAccountsByCustomer: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Accounts.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Accounts.Get.Parameters.Path;

    query: MittwaldApiV1.Paths.Customers_CustomerNumber_Accounts.Get.Parameters.Query;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Accounts.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/accounts",
  method: "get",
  operationId: "listAccountsByCustomer",
};

export const getBenefitDetails: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Benefits_Benefit.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Benefits_Benefit.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Benefits_Benefit.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/benefits/{benefit}",
  method: "get",
  operationId: "getBenefitDetails",
};

export const listContractsByCustomer: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Contracts.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Contracts.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Contracts.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/contracts",
  method: "get",
  operationId: "listContractsByCustomer",
};

export const listCancelledContractsByCustomer: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Cancelledcontracts.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Cancelledcontracts.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Cancelledcontracts.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/cancelledcontracts",
  method: "get",
  operationId: "listCancelledContractsByCustomer",
};

export const getAvContractStatus: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Dsgvocontractstatus.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Dsgvocontractstatus.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Dsgvocontractstatus.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/dsgvocontractstatus",
  method: "get",
  operationId: "getAvContractStatus",
};

export const getCustomerSettings: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Settings.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Settings.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Settings.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/settings",
  method: "get",
  operationId: "getCustomerSettings",
};

export const setCustomerSettings: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Customers_CustomerNumber_Settings.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Settings.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Settings.Post.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Settings.Post.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/settings",
  method: "post",
  operationId: "setCustomerSettings",
};

export const getInvoice: OperationDescriptor<
  {
    header: MittwaldApiV1.Paths.Invoices_InvoiceNumber.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Invoices_InvoiceNumber.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Invoices_InvoiceNumber.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/invoices/{invoiceNumber}",
  method: "get",
  operationId: "getInvoice",
};

export const getPaymentReceipts: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Invoices_InvoiceNumber_Paymentreceipts.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Invoices_InvoiceNumber_Paymentreceipts.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Invoices_InvoiceNumber_Paymentreceipts.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/invoices/{invoiceNumber}/paymentreceipts",
  method: "get",
  operationId: "getPaymentReceipts",
};

export const requestQuote: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Offers.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Offers.Post.Parameters.Header;
  },
  | ({ status: 202 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Offers.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Offers.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Offers.Post.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/offers",
  method: "post",
  operationId: "requestQuote",
};

export const orderPreUpgradeCheck: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Orders_PreUpgradeCheck_AccountIdentifier_ArticleNumber.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Orders_PreUpgradeCheck_AccountIdentifier_ArticleNumber.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_PreUpgradeCheck_AccountIdentifier_ArticleNumber.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_PreUpgradeCheck_AccountIdentifier_ArticleNumber.Get.Responses.$400.Content.Application_Json;
    })
  | ({ status: 401 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_PreUpgradeCheck_AccountIdentifier_ArticleNumber.Get.Responses.$401.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_PreUpgradeCheck_AccountIdentifier_ArticleNumber.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_PreUpgradeCheck_AccountIdentifier_ArticleNumber.Get.Responses.$404.Content.Application_Json;
    })
> = {
  path: "/orders/preUpgradeCheck/{accountIdentifier}/{articleNumber}",
  method: "get",
  operationId: "orderPreUpgradeCheck",
};

export const orderPartnerProgram: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Orders_Partnerprogram.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Orders_Partnerprogram.Post.Parameters.Header;
  },
  | ({ status: 202 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_Partnerprogram.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_Partnerprogram.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_Partnerprogram.Post.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/orders/partnerprogram",
  method: "post",
  operationId: "orderPartnerProgram",
};

export const orderPartnerBox: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Orders_Partnerbox.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Orders_Partnerbox.Post.Parameters.Header;
  },
  | ({ status: 202 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_Partnerbox.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_Partnerbox.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Orders_Partnerbox.Post.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/orders/partnerbox",
  method: "post",
  operationId: "orderPartnerBox",
};

export const listArticles: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Articles.Get.Parameters.Header;

    query: MittwaldApiV1.Paths.Articles.Get.Parameters.Query;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Articles.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/articles",
  method: "get",
  operationId: "listArticles",
};

export const getArticle: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Articles_ArticleNumber.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Articles_ArticleNumber.Get.Parameters.Path;

    query: MittwaldApiV1.Paths.Articles_ArticleNumber.Get.Parameters.Query;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Articles_ArticleNumber.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/articles/{articleNumber}",
  method: "get",
  operationId: "getArticle",
};

export const getCrossSellingOptions: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Articles_ArticleNumber_Cross_Selling.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Articles_ArticleNumber_Cross_Selling.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Articles_ArticleNumber_Cross_Selling.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/articles/{articleNumber}/cross-selling",
  method: "get",
  operationId: "getCrossSellingOptions",
};

export const getArticleUpgrades: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Articles_ArticleNumber_Upgrades.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Articles_ArticleNumber_Upgrades.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Articles_ArticleNumber_Upgrades.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/articles/{articleNumber}/upgrades",
  method: "get",
  operationId: "getArticleUpgrades",
};

export const createCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts.Post.Parameters.Header;
  },
  | { status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts.Post.Responses.$201.Content.Application_Json;
    }
> = {
  path: "/carts",
  method: "post",
  operationId: "createCart",
};

export const getCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/carts/{cartIdentifier}",
  method: "get",
  operationId: "getCart",
};

export const updateCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier.Put.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier.Put.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier.Put.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/carts/{cartIdentifier}",
  method: "put",
  operationId: "updateCart",
};

export const createCartFromTemplate: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier.Post.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier.Post.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/carts/{cartIdentifier}",
  method: "post",
  operationId: "createCartFromTemplate",
};

export const deleteCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier.Delete.Parameters.Path;
  },
  | { status: 204 } & {
      content: undefined;
    }
> = {
  path: "/carts/{cartIdentifier}",
  method: "delete",
  operationId: "deleteCart",
};

export const addItemToCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Items.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Items.Post.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier_Items.Post.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/carts/{cartIdentifier}/items",
  method: "post",
  operationId: "addItemToCart",
};

export const deleteItemFromCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Items_ItemIdentifier.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Items_ItemIdentifier.Delete.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier_Items_ItemIdentifier.Delete.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/carts/{cartIdentifier}/items/{itemIdentifier}",
  method: "delete",
  operationId: "deleteItemFromCart",
};

export const addDomainToCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Domains.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Domains.Post.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier_Domains.Post.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/carts/{cartIdentifier}/domains",
  method: "post",
  operationId: "addDomainToCart",
};

export const checkoutOrder: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Checkout.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Checkout.Post.Parameters.Path;
  },
  | { status: 200 } & {
      content: undefined;
    }
> = {
  path: "/carts/{cartIdentifier}/actions/checkout",
  method: "post",
  operationId: "checkoutOrder",
};

export const createQuoteFromCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Offer.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Offer.Post.Parameters.Path;
  },
  | { status: 200 } & {
      content: undefined;
    }
> = {
  path: "/carts/{cartIdentifier}/actions/offer",
  method: "post",
  operationId: "createQuoteFromCart",
};

export const shareCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Share.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Share.Post.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Share.Post.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/carts/{cartIdentifier}/actions/share",
  method: "post",
  operationId: "shareCart",
};

export const recommendCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Recommend.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Recommend.Post.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Recommend.Post.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/carts/{cartIdentifier}/actions/recommend",
  method: "post",
  operationId: "recommendCart",
};

export const verifyRecommendCart: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Recommendation_Verify.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Recommendation_Verify.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Recommendation_Verify.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Recommendation_Verify.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Recommendation_Verify.Post.Responses.$404.Content.Application_Json;
    })
> = {
  path: "/carts/{cartIdentifier}/actions/recommendation/verify",
  method: "post",
  operationId: "verifyRecommendCart",
};

export const requestSmsVerification: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Requestverification.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Requestverification.Post.Parameters.Path;
  },
  | { status: 200 } & {
      content: undefined;
    }
> = {
  path: "/carts/{cartIdentifier}/actions/requestverification",
  method: "post",
  operationId: "requestSmsVerification",
};

export const confirmSmsVerification: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Verify.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Carts_CartIdentifier_Actions_Verify.Post.Parameters.Path;
  },
  | { status: 200 } & {
      content: undefined;
    }
> = {
  path: "/carts/{cartIdentifier}/actions/verify",
  method: "post",
  operationId: "confirmSmsVerification",
};

export const checkDomainAvailability: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Domains_DomainIdentifier_Actions_Check.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Domains_DomainIdentifier_Actions_Check.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      content: undefined;
    })
  | ({ status: 410 } & {
      content: undefined;
    })
> = {
  path: "/domains/{domainIdentifier}/actions/check",
  method: "post",
  operationId: "checkDomainAvailability",
};

export const listToplevelDomains: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Topleveldomains.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Topleveldomains.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/topleveldomains",
  method: "get",
  operationId: "listToplevelDomains",
};

export const getToplevelDomain: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Topleveldomains_TopLevelDomainIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Topleveldomains_TopLevelDomainIdentifier.Get.Parameters.Path;

    query: MittwaldApiV1.Paths.Topleveldomains_TopLevelDomainIdentifier.Get.Parameters.Query;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Topleveldomains_TopLevelDomainIdentifier.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/topleveldomains/{topLevelDomainIdentifier}",
  method: "get",
  operationId: "getToplevelDomain",
};

export const getPromotionCode: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Promotioncodes_PromotionCode.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Promotioncodes_PromotionCode.Get.Parameters.Path;
  },
  | { status: 200 } & {
      content: undefined;
    }
> = {
  path: "/promotioncodes/{promotionCode}",
  method: "get",
  operationId: "getPromotionCode",
};

export const verifyPromotionCode: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Promotioncodes_PromotionCode_Actions_Validate.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Promotioncodes_PromotionCode_Actions_Validate.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      content: undefined;
    })
> = {
  path: "/promotioncodes/{promotionCode}/actions/validate",
  method: "post",
  operationId: "verifyPromotionCode",
};

export const listGuestOperatingSystems: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Virt_Guestoperatingsystems.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Virt_Guestoperatingsystems.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/virt/guestoperatingsystems",
  method: "get",
  operationId: "listGuestOperatingSystems",
};

export const convertBankDataToSepa: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Bankdata_Actions_Convert.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Bankdata_Actions_Convert.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Bankdata_Actions_Convert.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      content: undefined;
    })
> = {
  path: "/bankdata/actions/convert",
  method: "post",
  operationId: "convertBankDataToSepa",
};

export const listWebhooks: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Webhooks.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Webhooks.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/webhooks",
  method: "get",
  operationId: "listWebhooks",
};

export const createWebhook: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Webhooks.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Webhooks.Post.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Webhooks.Post.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/webhooks",
  method: "post",
  operationId: "createWebhook",
};

export const getWebhook: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/webhooks/{webhookIdentifier}",
  method: "get",
  operationId: "getWebhook",
};

export const updateWebhook: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Put.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Put.Parameters.Header;

    path: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Put.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/webhooks/{webhookIdentifier}",
  method: "put",
  operationId: "updateWebhook",
};

export const deleteWebhook: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Webhooks_WebhookIdentifier.Delete.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/webhooks/{webhookIdentifier}",
  method: "delete",
  operationId: "deleteWebhook",
};

export const cancelContract: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Cancellations.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Cancellations.Post.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Cancellations.Post.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/cancellations",
  method: "post",
  operationId: "cancelContract",
};

export const resendCancellationConfirmation: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Cancellations_CancellationIdentifier_Actions_Confirmationmail.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Cancellations_CancellationIdentifier_Actions_Confirmationmail.Post.Parameters.Path;
  },
  | ({ status: 202 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      content: undefined;
    })
  | ({ status: 500 } & {
      content: undefined;
    })
> = {
  path: "/cancellations/{cancellationIdentifier}/actions/confirmationmail",
  method: "post",
  operationId: "resendCancellationConfirmation",
};

export const getGdprpdFs: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Pdfs.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Pdfs.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/gdpr/pdfs",
  method: "get",
  operationId: "getGdprpdFs",
};

export const uploadGdprpdf: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Gdpr_Pdfs.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Gdpr_Pdfs.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Pdfs.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 500 } & {
      content: undefined;
    })
> = {
  path: "/gdpr/pdfs",
  method: "post",
  operationId: "uploadGdprpdf",
};

export const getGdprpdf: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/pdfs/{pdfIdentifier}",
  method: "get",
  operationId: "getGdprpdf",
};

export const deleteGdprpdf: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier.Delete.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/pdfs/{pdfIdentifier}",
  method: "delete",
  operationId: "deleteGdprpdf",
};

export const downloadGdprpdf: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier_Actions_Download.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier_Actions_Download.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Pdfs_PdfIdentifier_Actions_Download.Post.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/pdfs/{pdfIdentifier}/actions/download'",
  method: "post",
  operationId: "downloadGdprpdf",
};

export const getGdprContractPresets: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contract_Presets.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contract_Presets.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/gdpr/contract-presets",
  method: "get",
  operationId: "getGdprContractPresets",
};

export const createGdprContractPresets: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Gdpr_Contract_Presets.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Gdpr_Contract_Presets.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contract_Presets.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 500 } & {
      content: undefined;
    })
> = {
  path: "/gdpr/contract-presets",
  method: "post",
  operationId: "createGdprContractPresets",
};

export const getGdprContractPreset: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contract_Presets_ContractPresetIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Contract_Presets_ContractPresetIdentifier.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contract_Presets_ContractPresetIdentifier.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contract_Presets_ContractPresetIdentifier.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/contract-presets/{contractPresetIdentifier}",
  method: "get",
  operationId: "getGdprContractPreset",
};

export const getGdprContracts: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contracts.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/gdpr/contracts",
  method: "get",
  operationId: "getGdprContracts",
};

export const createGdprContract: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Gdpr_Contracts.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Gdpr_Contracts.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 500 } & {
      content: undefined;
    })
> = {
  path: "/gdpr/contracts",
  method: "post",
  operationId: "createGdprContract",
};

export const getGdprContract: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/contracts/{contractIdentifier}",
  method: "get",
  operationId: "getGdprContract",
};

export const deleteGdprContract: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier.Delete.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier.Delete.Responses.$403.Content.Application_Json;
    })
  | ({ status: 409 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier.Delete.Responses.$409.Content.Application_Json;
    })
> = {
  path: "/gdpr/contracts/{contractIdentifier}",
  method: "delete",
  operationId: "deleteGdprContract",
};

export const createGdprContractPdf: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Pdf.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Pdf.Post.Parameters.Path;
  },
  | ({ status: 200 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Pdf.Post.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/contracts/{contractIdentifier}/actions/pdf'",
  method: "post",
  operationId: "createGdprContractPdf",
};

export const sendGdprContractMail: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Mail.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Mail.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Mail.Post.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/contracts/{contractIdentifier}/actions/mail'",
  method: "post",
  operationId: "sendGdprContractMail",
};

export const acceptGdprContract: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Accept.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Accept.Post.Parameters.Path;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Accept.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contracts_ContractIdentifier_Actions_Accept.Post.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/contracts/{contractIdentifier}/actions/accept'",
  method: "post",
  operationId: "acceptGdprContract",
};

export const getGdprContacts: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contacts.Get.Parameters.Header;

    query: MittwaldApiV1.Paths.Gdpr_Contacts.Get.Parameters.Query;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contacts.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/gdpr/contacts",
  method: "get",
  operationId: "getGdprContacts",
};

export const createGdprContact: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Gdpr_Contacts.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Gdpr_Contacts.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contacts.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 500 } & {
      content: undefined;
    })
> = {
  path: "/gdpr/contacts",
  method: "post",
  operationId: "createGdprContact",
};

export const getGdprContact: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Contacts_ContactIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Contacts_ContactIdentifier.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contacts_ContactIdentifier.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Contacts_ContactIdentifier.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/contacts/{contactIdentifier}",
  method: "get",
  operationId: "getGdprContact",
};

export const getGdprToms: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Toms.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Toms.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/gdpr/toms",
  method: "get",
  operationId: "getGdprToms",
};

export const createGdprTom: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Gdpr_Toms.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Gdpr_Toms.Post.Parameters.Header;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Toms.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 500 } & {
      content: undefined;
    })
> = {
  path: "/gdpr/toms",
  method: "post",
  operationId: "createGdprTom",
};

export const getGdprTom: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Gdpr_Toms_TomIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Gdpr_Toms_TomIdentifier.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Toms_TomIdentifier.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Gdpr_Toms_TomIdentifier.Get.Responses.$403.Content.Application_Json;
    })
> = {
  path: "/gdpr/toms/{tomIdentifier}",
  method: "get",
  operationId: "getGdprTom",
};

export const listSupportTickets: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Tickets.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Tickets.Get.Parameters.Path;

    query: MittwaldApiV1.Paths.Customers_CustomerNumber_Tickets.Get.Parameters.Query;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Tickets.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/customers/{customerNumber}/tickets",
  method: "get",
  operationId: "listSupportTickets",
};

export const createSupportTicket: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Tickets.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Tickets.Post.Parameters.Header;
  },
  | { status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Tickets.Post.Responses.$201.Content.Application_Json;
    }
> = {
  path: "/tickets",
  method: "post",
  operationId: "createSupportTicket",
};

export const getSupportTicket: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Tickets_TicketIdentifier.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Tickets_TicketIdentifier.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Tickets_TicketIdentifier.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/tickets/{ticketIdentifier}",
  method: "get",
  operationId: "getSupportTicket",
};

export const listSupportTicketAnswers: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Answers.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Answers.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Answers.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/tickets/{ticketIdentifier}/answers",
  method: "get",
  operationId: "listSupportTicketAnswers",
};

export const answerSupportTicket: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Answers.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Answers.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Answers.Post.Parameters.Path;
  },
  | { status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Answers.Post.Responses.$201.Content.Application_Json;
    }
> = {
  path: "/tickets/{ticketIdentifier}/answers",
  method: "post",
  operationId: "answerSupportTicket",
};

export const closeSupportTicket: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Actions_Close.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Actions_Close.Post.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Tickets_TicketIdentifier_Actions_Close.Post.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/tickets/{ticketIdentifier}/actions/close",
  method: "post",
  operationId: "closeSupportTicket",
};

export const listTicketCategories: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Ticket_Categories.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Ticket_Categories.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/ticket-categories",
  method: "get",
  operationId: "listTicketCategories",
};

export const getAllowedFileTypes: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Daemoncloud_Allowed.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Daemoncloud_Allowed.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/daemoncloud/allowed",
  method: "get",
  operationId: "getAllowedFileTypes",
};

export const uploadFile: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Daemoncloud_Files.Post.Parameters.Header;
  },
  | { status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Daemoncloud_Files.Post.Responses.$201.Content.Application_Json;
    }
> = {
  path: "/daemoncloud/files",
  method: "post",
  operationId: "uploadFile",
};

export const getFile: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Daemoncloud_Files_FileId.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Daemoncloud_Files_FileId.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "text/plain";
      content: MittwaldApiV1.Paths.Daemoncloud_Files_FileId.Get.Responses.$200.Content.Text_Plain;
    }
> = {
  path: "/daemoncloud/files/{fileId}",
  method: "get",
  operationId: "getFile",
};

export const deleteFile: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Daemoncloud_Files_FileId.Delete.Parameters.Header;

    path: MittwaldApiV1.Paths.Daemoncloud_Files_FileId.Delete.Parameters.Path;
  },
  | { status: 200 } & {
      content: undefined;
    }
> = {
  path: "/daemoncloud/files/{fileId}",
  method: "delete",
  operationId: "deleteFile",
};

export const getFileDetails: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Daemoncloud_Files_FileId_Details.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Daemoncloud_Files_FileId_Details.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Daemoncloud_Files_FileId_Details.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/daemoncloud/files/{fileId}/details",
  method: "get",
  operationId: "getFileDetails",
};

export const getAccountVisitorStatistics: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Stats_Visitors.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Stats_Visitors.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Stats_Visitors.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/accounts/{accountIdentifier}/stats/visitors",
  method: "get",
  operationId: "getAccountVisitorStatistics",
};

export const getAccountStatistics: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Stats.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Stats.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Stats.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/accounts/{accountIdentifier}/stats",
  method: "get",
  operationId: "getAccountStatistics",
};

export const getPhoneVerificationCode: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.PhoneVerification_Customernumber.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.PhoneVerification_Customernumber.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.PhoneVerification_Customernumber.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/phoneVerification/{customernumber}",
  method: "get",
  operationId: "getPhoneVerificationCode",
};

export const getNavigation: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Menu.Get.Parameters.Header;

    query: MittwaldApiV1.Paths.Menu.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Menu.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Menu.Get.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/menu",
  method: "get",
  operationId: "getNavigation",
};

export const getNavigationMeta: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.MenuMeta.Get.Parameters.Header;

    query: MittwaldApiV1.Paths.MenuMeta.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.MenuMeta.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.MenuMeta.Get.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/menuMeta",
  method: "get",
  operationId: "getNavigationMeta",
};

export const search: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Search.Get.Parameters.Header;

    query: MittwaldApiV1.Paths.Search.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Search.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Search.Get.Responses.$400.Content.Application_Json;
    })
> = {
  path: "/search",
  method: "get",
  operationId: "search",
};

export const getDomainOverview: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_DomainOverview.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_DomainOverview.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_DomainOverview.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_DomainOverview.Get.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/domainOverview",
  method: "get",
  operationId: "getDomainOverview",
};

export const getDnsOverview: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Dns.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Dns.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Dns.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Dns.Get.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/dns",
  method: "get",
  operationId: "getDnsOverview",
};

export const getAccountIpAddresses: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Ip_Addresses.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Ip_Addresses.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Ip_Addresses.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Ip_Addresses.Get.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/ip-addresses",
  method: "get",
  operationId: "getAccountIpAddresses",
};

export const updateDnsRecords: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Dns_DomainIdentifier.Put.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Dns_DomainIdentifier.Put.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Dns_DomainIdentifier.Put.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Dns_DomainIdentifier.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Dns_DomainIdentifier.Put.Responses.$400.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/dns/{domainIdentifier}",
  method: "put",
  operationId: "updateDnsRecords",
};

export const getFlag: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Flagging_Flags_FlagId.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Flagging_Flags_FlagId.Get.Parameters.Path;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Flagging_Flags_FlagId.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/flagging/flags/{flagId}",
  method: "get",
  operationId: "getFlag",
};

export const changeAccountPassword: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Accounts_Account_Actions_Change_Password.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Accounts_Account_Actions_Change_Password.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_Account_Actions_Change_Password.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_Account_Actions_Change_Password.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_Account_Actions_Change_Password.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_Account_Actions_Change_Password.Post.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/accounts/{account}/actions/change-password",
  method: "post",
  operationId: "changeAccountPassword",
};

export const changeCustomerPassword: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Customers_CustomerNumber_Actions_Change_Password.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Actions_Change_Password.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Actions_Change_Password.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Actions_Change_Password.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Actions_Change_Password.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Actions_Change_Password.Post.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/customers/{customerNumber}/actions/change-password",
  method: "post",
  operationId: "changeCustomerPassword",
};

export const initMfaAction: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Mfa_Actions_Init.Post.Parameters.RequestBody;

    header: MittwaldApiV1.Paths.Mfa_Actions_Init.Post.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Mfa_Actions_Init.Post.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/mfa/actions/init",
  method: "post",
  operationId: "initMfaAction",
};

export const confirmMfa: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Mfa_Actions_Confirm.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Mfa_Actions_Confirm.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Mfa_Actions_Confirm.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Mfa_Actions_Confirm.Post.Responses.$400.Content.Application_Json;
    })
> = {
  path: "/mfa/actions/confirm",
  method: "post",
  operationId: "confirmMfa",
};

export const getMfaStatus: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Mfa.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Mfa.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/mfa",
  method: "get",
  operationId: "getMfaStatus",
};

export const resetRecoveryCodes: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Mfa.Put.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Mfa.Put.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Mfa.Put.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Mfa.Put.Responses.$400.Content.Application_Json;
    })
> = {
  path: "/mfa",
  method: "put",
  operationId: "resetRecoveryCodes",
};

export const deleteMfa: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Mfa.Delete.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Mfa.Delete.Parameters.Header;
  },
  | ({ status: 204 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Mfa.Delete.Responses.$400.Content.Application_Json;
    })
> = {
  path: "/mfa",
  method: "delete",
  operationId: "deleteMfa",
};

export const getMfaSecret: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Mfa_Secret.Get.Parameters.Header;

    query: MittwaldApiV1.Paths.Mfa_Secret.Get.Parameters.Query;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Mfa_Secret.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/mfa/secret",
  method: "get",
  operationId: "getMfaSecret",
};

export const verifyToken: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Verify.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Verify.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      content: undefined;
    })
  | ({ status: 400 } & {
      content: undefined;
    })
  | ({ status: 403 } & {
      content: undefined;
    })
> = {
  path: "/verify",
  method: "post",
  operationId: "verifyToken",
};

export const signToken: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Sign.Post.Parameters.RequestBody;

    header: MittwaldApiV1.Paths.Sign.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Sign.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 200 } & {
      mediaType: "application/jwt";
      content: MittwaldApiV1.Paths.Sign.Post.Responses.$200.Content.Application_Jwt;
    })
> = {
  path: "/sign",
  method: "post",
  operationId: "signToken",
};

export const getPublicKey: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Key.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/x-pem-file";
      content: MittwaldApiV1.Paths.Key.Get.Responses.$200.Content.Application_X_Pem_File;
    }
> = {
  path: "/key",
  method: "get",
  operationId: "getPublicKey",
};

export const getIsShowFeedback: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Is_Show_Feedback.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Is_Show_Feedback.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Is_Show_Feedback.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Is_Show_Feedback.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Is_Show_Feedback.Get.Responses.$404.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Is_Show_Feedback.Get.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/customers/{customerNumber}/is-show-feedback",
  method: "get",
  operationId: "getIsShowFeedback",
};

export const createFeedback: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Parameters.Header;

    path: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Parameters.Path;
  },
  | ({ status: 201 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Responses.$201.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Responses.$404.Content.Application_Json;
    })
  | ({ status: 422 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Responses.$422.Content.Application_Json;
    })
  | ({ status: 425 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Responses.$425.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Customers_CustomerNumber_Feedback.Post.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/customers/{customerNumber}/feedback",
  method: "post",
  operationId: "createFeedback",
};

export const accountListBlockedBots: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Get.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Get.Parameters.Path;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Get.Responses.$403.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Get.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/blocked-bots",
  method: "get",
  operationId: "accountListBlockedBots",
};

export const accountSetBlockedBots: OperationDescriptor<
  {
    requestBody: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Put.Parameters.RequestBody;

    header?: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Put.Parameters.Header;

    path: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Put.Parameters.Path;
  },
  | ({ status: 204 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Put.Responses.$204.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Put.Responses.$403.Content.Application_Json;
    })
  | ({ status: 404 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Put.Responses.$404.Content.Application_Json;
    })
  | ({ status: 422 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Put.Responses.$422.Content.Application_Json;
    })
  | ({ status: 429 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Put.Responses.$429.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Accounts_AccountIdentifier_Blocked_Bots.Put.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/accounts/{accountIdentifier}/blocked-bots",
  method: "put",
  operationId: "accountSetBlockedBots",
};

export const accountListDefaultBlockedBots: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Account_Default_Blocked_Bots.Get.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Account_Default_Blocked_Bots.Get.Responses.$200.Content.Application_Json;
    })
  | ({ status: 500 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Account_Default_Blocked_Bots.Get.Responses.$500.Content.Application_Json;
    })
> = {
  path: "/account-default-blocked-bots",
  method: "get",
  operationId: "accountListDefaultBlockedBots",
};

export const listPublicToplevelDomains: OperationDescriptor<
  {
    header?: MittwaldApiV1.Paths.Public_Topleveldomains.Get.Parameters.Header;
  },
  | { status: 200 } & {
      mediaType: "application/json";
      content: MittwaldApiV1.Paths.Public_Topleveldomains.Get.Responses.$200.Content.Application_Json;
    }
> = {
  path: "/public/topleveldomains",
  method: "get",
  operationId: "listPublicToplevelDomains",
};

/**
 * ====================================
 * Client
 * ====================================
 */
export class MittwaldApiV1Client {
  private static instance: MittwaldApiV1Client | undefined;

  public static getInstance(): MittwaldApiV1Client {
    const requireClientInstanceMethod = (
      methodName: string | symbol
    ): Function => {
      const client = MittwaldApiV1Client.instance as
        | undefined
        | Record<string | symbol, any>;

      if (!client) {
        throw new Error(
          "ApiClientInstanceNotSet: API-Client-instance must be set before using hooks. Use MittwaldApiV1Client.setInstance()."
        );
      }

      if (!(methodName in client)) {
        throw new Error(
          `InvalidMethodCall: Could not find method ${String(
            methodName
          )} in MittwaldApiV1Client`
        );
      }

      const method = client[methodName];

      if (typeof method !== "function") {
        throw new Error(
          `InvalidMethodCall: ${String(
            methodName
          )} in MittwaldApiV1Client is not a function`
        );
      }

      return method;
    };

    /**
     * Catch access to all props and return proxy method that proxies
     * calls to the underlying client instance, while accessing the instance
     * at call-time.
     */
    const lazyAccessingClientInstanceHandler: ProxyHandler<MittwaldApiV1Client> =
      {
        get(client, prop) {
          return (...params: any[]) =>
            requireClientInstanceMethod(prop)(...params);
        },
      };

    return new Proxy(
      {} as MittwaldApiV1Client,
      lazyAccessingClientInstanceHandler
    );
  }

  public static setInstance(client: MittwaldApiV1Client): void {
    MittwaldApiV1Client.instance = client;
  }

  public listApplicationTokens: RequestFunction<typeof listApplicationTokens>;

  public createApplicationToken: RequestFunction<typeof createApplicationToken>;

  public getAccessToken: RequestFunction<typeof getAccessToken>;

  public deleteApplicationToken: RequestFunction<typeof deleteApplicationToken>;

  public getUserName: RequestFunction<typeof getUserName>;

  public getAccount: RequestFunction<typeof getAccount>;

  public updateAccount: RequestFunction<typeof updateAccount>;

  public getNotifications: RequestFunction<typeof getNotifications>;

  public deleteNotifications: RequestFunction<typeof deleteNotifications>;

  public getReseller: RequestFunction<typeof getReseller>;

  public listDatabaseTypes: RequestFunction<typeof listDatabaseTypes>;

  public listDomainsByAccount: RequestFunction<typeof listDomainsByAccount>;

  public registerNewDomain: RequestFunction<typeof registerNewDomain>;

  public domainProxyList: RequestFunction<typeof domainProxyList>;

  public deleteDomain: RequestFunction<typeof deleteDomain>;

  public getDomainAuthCode: RequestFunction<typeof getDomainAuthCode>;

  public listSubdomainsByDomain: RequestFunction<typeof listSubdomainsByDomain>;

  public createSubdomain: RequestFunction<typeof createSubdomain>;

  public deleteSubdomain: RequestFunction<typeof deleteSubdomain>;

  public getSubdomain: RequestFunction<typeof getSubdomain>;

  public listEmailAddressesByAccount: RequestFunction<
    typeof listEmailAddressesByAccount
  >;

  public listSoftwares: RequestFunction<typeof listSoftwares>;

  public listSoftwareInstallationsByAccount: RequestFunction<
    typeof listSoftwareInstallationsByAccount
  >;

  public updatePhp: RequestFunction<typeof updatePhp>;

  public getSoftwareInstallation: RequestFunction<
    typeof getSoftwareInstallation
  >;

  public listSoftwareInstallationExtensions: RequestFunction<
    typeof listSoftwareInstallationExtensions
  >;

  public getCurrentCustomer: RequestFunction<typeof getCurrentCustomer>;

  public getOwnCustomer: RequestFunction<typeof getOwnCustomer>;

  public getCustomer: RequestFunction<typeof getCustomer>;

  public getCustomerContractPartner: RequestFunction<
    typeof getCustomerContractPartner
  >;

  public updateCustomerContractPartner: RequestFunction<
    typeof updateCustomerContractPartner
  >;

  public getCustomerContactPerson: RequestFunction<
    typeof getCustomerContactPerson
  >;

  public updateCustomerContactPerson: RequestFunction<
    typeof updateCustomerContactPerson
  >;

  public getCustomerPaymentSettings: RequestFunction<
    typeof getCustomerPaymentSettings
  >;

  public updateCustomerPaymentSettings: RequestFunction<
    typeof updateCustomerPaymentSettings
  >;

  public getCustomerBillingRecipient: RequestFunction<
    typeof getCustomerBillingRecipient
  >;

  public updateCustomerBillingRecipient: RequestFunction<
    typeof updateCustomerBillingRecipient
  >;

  public resetCustomerBillingRecipient: RequestFunction<
    typeof resetCustomerBillingRecipient
  >;

  public getCustomerBillingSettings: RequestFunction<
    typeof getCustomerBillingSettings
  >;

  public updateCustomerBillingSettings: RequestFunction<
    typeof updateCustomerBillingSettings
  >;

  public listInvoicesByCustomer: RequestFunction<typeof listInvoicesByCustomer>;

  public listAccountsByCustomer: RequestFunction<typeof listAccountsByCustomer>;

  public getBenefitDetails: RequestFunction<typeof getBenefitDetails>;

  public listContractsByCustomer: RequestFunction<
    typeof listContractsByCustomer
  >;

  public listCancelledContractsByCustomer: RequestFunction<
    typeof listCancelledContractsByCustomer
  >;

  public getAvContractStatus: RequestFunction<typeof getAvContractStatus>;

  public getCustomerSettings: RequestFunction<typeof getCustomerSettings>;

  public setCustomerSettings: RequestFunction<typeof setCustomerSettings>;

  public getInvoice: RequestFunction<typeof getInvoice>;

  public getPaymentReceipts: RequestFunction<typeof getPaymentReceipts>;

  public requestQuote: RequestFunction<typeof requestQuote>;

  public orderPreUpgradeCheck: RequestFunction<typeof orderPreUpgradeCheck>;

  public orderPartnerProgram: RequestFunction<typeof orderPartnerProgram>;

  public orderPartnerBox: RequestFunction<typeof orderPartnerBox>;

  public listArticles: RequestFunction<typeof listArticles>;

  public getArticle: RequestFunction<typeof getArticle>;

  public getCrossSellingOptions: RequestFunction<typeof getCrossSellingOptions>;

  public getArticleUpgrades: RequestFunction<typeof getArticleUpgrades>;

  public createCart: RequestFunction<typeof createCart>;

  public getCart: RequestFunction<typeof getCart>;

  public updateCart: RequestFunction<typeof updateCart>;

  public createCartFromTemplate: RequestFunction<typeof createCartFromTemplate>;

  public deleteCart: RequestFunction<typeof deleteCart>;

  public addItemToCart: RequestFunction<typeof addItemToCart>;

  public deleteItemFromCart: RequestFunction<typeof deleteItemFromCart>;

  public addDomainToCart: RequestFunction<typeof addDomainToCart>;

  public checkoutOrder: RequestFunction<typeof checkoutOrder>;

  public createQuoteFromCart: RequestFunction<typeof createQuoteFromCart>;

  public shareCart: RequestFunction<typeof shareCart>;

  public recommendCart: RequestFunction<typeof recommendCart>;

  public verifyRecommendCart: RequestFunction<typeof verifyRecommendCart>;

  public requestSmsVerification: RequestFunction<typeof requestSmsVerification>;

  public confirmSmsVerification: RequestFunction<typeof confirmSmsVerification>;

  public checkDomainAvailability: RequestFunction<
    typeof checkDomainAvailability
  >;

  public listToplevelDomains: RequestFunction<typeof listToplevelDomains>;

  public getToplevelDomain: RequestFunction<typeof getToplevelDomain>;

  public getPromotionCode: RequestFunction<typeof getPromotionCode>;

  public verifyPromotionCode: RequestFunction<typeof verifyPromotionCode>;

  public listGuestOperatingSystems: RequestFunction<
    typeof listGuestOperatingSystems
  >;

  public convertBankDataToSepa: RequestFunction<typeof convertBankDataToSepa>;

  public listWebhooks: RequestFunction<typeof listWebhooks>;

  public createWebhook: RequestFunction<typeof createWebhook>;

  public getWebhook: RequestFunction<typeof getWebhook>;

  public updateWebhook: RequestFunction<typeof updateWebhook>;

  public deleteWebhook: RequestFunction<typeof deleteWebhook>;

  public cancelContract: RequestFunction<typeof cancelContract>;

  public resendCancellationConfirmation: RequestFunction<
    typeof resendCancellationConfirmation
  >;

  public getGdprpdFs: RequestFunction<typeof getGdprpdFs>;

  public uploadGdprpdf: RequestFunction<typeof uploadGdprpdf>;

  public getGdprpdf: RequestFunction<typeof getGdprpdf>;

  public deleteGdprpdf: RequestFunction<typeof deleteGdprpdf>;

  public downloadGdprpdf: RequestFunction<typeof downloadGdprpdf>;

  public getGdprContractPresets: RequestFunction<typeof getGdprContractPresets>;

  public createGdprContractPresets: RequestFunction<
    typeof createGdprContractPresets
  >;

  public getGdprContractPreset: RequestFunction<typeof getGdprContractPreset>;

  public getGdprContracts: RequestFunction<typeof getGdprContracts>;

  public createGdprContract: RequestFunction<typeof createGdprContract>;

  public getGdprContract: RequestFunction<typeof getGdprContract>;

  public deleteGdprContract: RequestFunction<typeof deleteGdprContract>;

  public createGdprContractPdf: RequestFunction<typeof createGdprContractPdf>;

  public sendGdprContractMail: RequestFunction<typeof sendGdprContractMail>;

  public acceptGdprContract: RequestFunction<typeof acceptGdprContract>;

  public getGdprContacts: RequestFunction<typeof getGdprContacts>;

  public createGdprContact: RequestFunction<typeof createGdprContact>;

  public getGdprContact: RequestFunction<typeof getGdprContact>;

  public getGdprToms: RequestFunction<typeof getGdprToms>;

  public createGdprTom: RequestFunction<typeof createGdprTom>;

  public getGdprTom: RequestFunction<typeof getGdprTom>;

  public listSupportTickets: RequestFunction<typeof listSupportTickets>;

  public createSupportTicket: RequestFunction<typeof createSupportTicket>;

  public getSupportTicket: RequestFunction<typeof getSupportTicket>;

  public listSupportTicketAnswers: RequestFunction<
    typeof listSupportTicketAnswers
  >;

  public answerSupportTicket: RequestFunction<typeof answerSupportTicket>;

  public closeSupportTicket: RequestFunction<typeof closeSupportTicket>;

  public listTicketCategories: RequestFunction<typeof listTicketCategories>;

  public getAllowedFileTypes: RequestFunction<typeof getAllowedFileTypes>;

  public uploadFile: RequestFunction<typeof uploadFile>;

  public getFile: RequestFunction<typeof getFile>;

  public deleteFile: RequestFunction<typeof deleteFile>;

  public getFileDetails: RequestFunction<typeof getFileDetails>;

  public getAccountVisitorStatistics: RequestFunction<
    typeof getAccountVisitorStatistics
  >;

  public getAccountStatistics: RequestFunction<typeof getAccountStatistics>;

  public getPhoneVerificationCode: RequestFunction<
    typeof getPhoneVerificationCode
  >;

  public getNavigation: RequestFunction<typeof getNavigation>;

  public getNavigationMeta: RequestFunction<typeof getNavigationMeta>;

  public search: RequestFunction<typeof search>;

  public getDomainOverview: RequestFunction<typeof getDomainOverview>;

  public getDnsOverview: RequestFunction<typeof getDnsOverview>;

  public getAccountIpAddresses: RequestFunction<typeof getAccountIpAddresses>;

  public updateDnsRecords: RequestFunction<typeof updateDnsRecords>;

  public getFlag: RequestFunction<typeof getFlag>;

  public changeAccountPassword: RequestFunction<typeof changeAccountPassword>;

  public changeCustomerPassword: RequestFunction<typeof changeCustomerPassword>;

  public initMfaAction: RequestFunction<typeof initMfaAction>;

  public confirmMfa: RequestFunction<typeof confirmMfa>;

  public getMfaStatus: RequestFunction<typeof getMfaStatus>;

  public resetRecoveryCodes: RequestFunction<typeof resetRecoveryCodes>;

  public deleteMfa: RequestFunction<typeof deleteMfa>;

  public getMfaSecret: RequestFunction<typeof getMfaSecret>;

  public verifyToken: RequestFunction<typeof verifyToken>;

  public signToken: RequestFunction<typeof signToken>;

  public getPublicKey: RequestFunction<typeof getPublicKey>;

  public getIsShowFeedback: RequestFunction<typeof getIsShowFeedback>;

  public createFeedback: RequestFunction<typeof createFeedback>;

  public accountListBlockedBots: RequestFunction<typeof accountListBlockedBots>;

  public accountSetBlockedBots: RequestFunction<typeof accountSetBlockedBots>;

  public accountListDefaultBlockedBots: RequestFunction<
    typeof accountListDefaultBlockedBots
  >;

  public listPublicToplevelDomains: RequestFunction<
    typeof listPublicToplevelDomains
  >;

  public constructor(clientOrUrl: Client | string) {
    const client =
      typeof clientOrUrl === "string"
        ? new KyClient({ ky: { prefixUrl: clientOrUrl } })
        : clientOrUrl;

    this.listApplicationTokens = client.requestFunctionFactory(
      listApplicationTokens
    );

    this.createApplicationToken = client.requestFunctionFactory(
      createApplicationToken
    );

    this.getAccessToken = client.requestFunctionFactory(getAccessToken);

    this.deleteApplicationToken = client.requestFunctionFactory(
      deleteApplicationToken
    );

    this.getUserName = client.requestFunctionFactory(getUserName);

    this.getAccount = client.requestFunctionFactory(getAccount);

    this.updateAccount = client.requestFunctionFactory(updateAccount);

    this.getNotifications = client.requestFunctionFactory(getNotifications);

    this.deleteNotifications =
      client.requestFunctionFactory(deleteNotifications);

    this.getReseller = client.requestFunctionFactory(getReseller);

    this.listDatabaseTypes = client.requestFunctionFactory(listDatabaseTypes);

    this.listDomainsByAccount =
      client.requestFunctionFactory(listDomainsByAccount);

    this.registerNewDomain = client.requestFunctionFactory(registerNewDomain);

    this.domainProxyList = client.requestFunctionFactory(domainProxyList);

    this.deleteDomain = client.requestFunctionFactory(deleteDomain);

    this.getDomainAuthCode = client.requestFunctionFactory(getDomainAuthCode);

    this.listSubdomainsByDomain = client.requestFunctionFactory(
      listSubdomainsByDomain
    );

    this.createSubdomain = client.requestFunctionFactory(createSubdomain);

    this.deleteSubdomain = client.requestFunctionFactory(deleteSubdomain);

    this.getSubdomain = client.requestFunctionFactory(getSubdomain);

    this.listEmailAddressesByAccount = client.requestFunctionFactory(
      listEmailAddressesByAccount
    );

    this.listSoftwares = client.requestFunctionFactory(listSoftwares);

    this.listSoftwareInstallationsByAccount = client.requestFunctionFactory(
      listSoftwareInstallationsByAccount
    );

    this.updatePhp = client.requestFunctionFactory(updatePhp);

    this.getSoftwareInstallation = client.requestFunctionFactory(
      getSoftwareInstallation
    );

    this.listSoftwareInstallationExtensions = client.requestFunctionFactory(
      listSoftwareInstallationExtensions
    );

    this.getCurrentCustomer = client.requestFunctionFactory(getCurrentCustomer);

    this.getOwnCustomer = client.requestFunctionFactory(getOwnCustomer);

    this.getCustomer = client.requestFunctionFactory(getCustomer);

    this.getCustomerContractPartner = client.requestFunctionFactory(
      getCustomerContractPartner
    );

    this.updateCustomerContractPartner = client.requestFunctionFactory(
      updateCustomerContractPartner
    );

    this.getCustomerContactPerson = client.requestFunctionFactory(
      getCustomerContactPerson
    );

    this.updateCustomerContactPerson = client.requestFunctionFactory(
      updateCustomerContactPerson
    );

    this.getCustomerPaymentSettings = client.requestFunctionFactory(
      getCustomerPaymentSettings
    );

    this.updateCustomerPaymentSettings = client.requestFunctionFactory(
      updateCustomerPaymentSettings
    );

    this.getCustomerBillingRecipient = client.requestFunctionFactory(
      getCustomerBillingRecipient
    );

    this.updateCustomerBillingRecipient = client.requestFunctionFactory(
      updateCustomerBillingRecipient
    );

    this.resetCustomerBillingRecipient = client.requestFunctionFactory(
      resetCustomerBillingRecipient
    );

    this.getCustomerBillingSettings = client.requestFunctionFactory(
      getCustomerBillingSettings
    );

    this.updateCustomerBillingSettings = client.requestFunctionFactory(
      updateCustomerBillingSettings
    );

    this.listInvoicesByCustomer = client.requestFunctionFactory(
      listInvoicesByCustomer
    );

    this.listAccountsByCustomer = client.requestFunctionFactory(
      listAccountsByCustomer
    );

    this.getBenefitDetails = client.requestFunctionFactory(getBenefitDetails);

    this.listContractsByCustomer = client.requestFunctionFactory(
      listContractsByCustomer
    );

    this.listCancelledContractsByCustomer = client.requestFunctionFactory(
      listCancelledContractsByCustomer
    );

    this.getAvContractStatus =
      client.requestFunctionFactory(getAvContractStatus);

    this.getCustomerSettings =
      client.requestFunctionFactory(getCustomerSettings);

    this.setCustomerSettings =
      client.requestFunctionFactory(setCustomerSettings);

    this.getInvoice = client.requestFunctionFactory(getInvoice);

    this.getPaymentReceipts = client.requestFunctionFactory(getPaymentReceipts);

    this.requestQuote = client.requestFunctionFactory(requestQuote);

    this.orderPreUpgradeCheck =
      client.requestFunctionFactory(orderPreUpgradeCheck);

    this.orderPartnerProgram =
      client.requestFunctionFactory(orderPartnerProgram);

    this.orderPartnerBox = client.requestFunctionFactory(orderPartnerBox);

    this.listArticles = client.requestFunctionFactory(listArticles);

    this.getArticle = client.requestFunctionFactory(getArticle);

    this.getCrossSellingOptions = client.requestFunctionFactory(
      getCrossSellingOptions
    );

    this.getArticleUpgrades = client.requestFunctionFactory(getArticleUpgrades);

    this.createCart = client.requestFunctionFactory(createCart);

    this.getCart = client.requestFunctionFactory(getCart);

    this.updateCart = client.requestFunctionFactory(updateCart);

    this.createCartFromTemplate = client.requestFunctionFactory(
      createCartFromTemplate
    );

    this.deleteCart = client.requestFunctionFactory(deleteCart);

    this.addItemToCart = client.requestFunctionFactory(addItemToCart);

    this.deleteItemFromCart = client.requestFunctionFactory(deleteItemFromCart);

    this.addDomainToCart = client.requestFunctionFactory(addDomainToCart);

    this.checkoutOrder = client.requestFunctionFactory(checkoutOrder);

    this.createQuoteFromCart =
      client.requestFunctionFactory(createQuoteFromCart);

    this.shareCart = client.requestFunctionFactory(shareCart);

    this.recommendCart = client.requestFunctionFactory(recommendCart);

    this.verifyRecommendCart =
      client.requestFunctionFactory(verifyRecommendCart);

    this.requestSmsVerification = client.requestFunctionFactory(
      requestSmsVerification
    );

    this.confirmSmsVerification = client.requestFunctionFactory(
      confirmSmsVerification
    );

    this.checkDomainAvailability = client.requestFunctionFactory(
      checkDomainAvailability
    );

    this.listToplevelDomains =
      client.requestFunctionFactory(listToplevelDomains);

    this.getToplevelDomain = client.requestFunctionFactory(getToplevelDomain);

    this.getPromotionCode = client.requestFunctionFactory(getPromotionCode);

    this.verifyPromotionCode =
      client.requestFunctionFactory(verifyPromotionCode);

    this.listGuestOperatingSystems = client.requestFunctionFactory(
      listGuestOperatingSystems
    );

    this.convertBankDataToSepa = client.requestFunctionFactory(
      convertBankDataToSepa
    );

    this.listWebhooks = client.requestFunctionFactory(listWebhooks);

    this.createWebhook = client.requestFunctionFactory(createWebhook);

    this.getWebhook = client.requestFunctionFactory(getWebhook);

    this.updateWebhook = client.requestFunctionFactory(updateWebhook);

    this.deleteWebhook = client.requestFunctionFactory(deleteWebhook);

    this.cancelContract = client.requestFunctionFactory(cancelContract);

    this.resendCancellationConfirmation = client.requestFunctionFactory(
      resendCancellationConfirmation
    );

    this.getGdprpdFs = client.requestFunctionFactory(getGdprpdFs);

    this.uploadGdprpdf = client.requestFunctionFactory(uploadGdprpdf);

    this.getGdprpdf = client.requestFunctionFactory(getGdprpdf);

    this.deleteGdprpdf = client.requestFunctionFactory(deleteGdprpdf);

    this.downloadGdprpdf = client.requestFunctionFactory(downloadGdprpdf);

    this.getGdprContractPresets = client.requestFunctionFactory(
      getGdprContractPresets
    );

    this.createGdprContractPresets = client.requestFunctionFactory(
      createGdprContractPresets
    );

    this.getGdprContractPreset = client.requestFunctionFactory(
      getGdprContractPreset
    );

    this.getGdprContracts = client.requestFunctionFactory(getGdprContracts);

    this.createGdprContract = client.requestFunctionFactory(createGdprContract);

    this.getGdprContract = client.requestFunctionFactory(getGdprContract);

    this.deleteGdprContract = client.requestFunctionFactory(deleteGdprContract);

    this.createGdprContractPdf = client.requestFunctionFactory(
      createGdprContractPdf
    );

    this.sendGdprContractMail =
      client.requestFunctionFactory(sendGdprContractMail);

    this.acceptGdprContract = client.requestFunctionFactory(acceptGdprContract);

    this.getGdprContacts = client.requestFunctionFactory(getGdprContacts);

    this.createGdprContact = client.requestFunctionFactory(createGdprContact);

    this.getGdprContact = client.requestFunctionFactory(getGdprContact);

    this.getGdprToms = client.requestFunctionFactory(getGdprToms);

    this.createGdprTom = client.requestFunctionFactory(createGdprTom);

    this.getGdprTom = client.requestFunctionFactory(getGdprTom);

    this.listSupportTickets = client.requestFunctionFactory(listSupportTickets);

    this.createSupportTicket =
      client.requestFunctionFactory(createSupportTicket);

    this.getSupportTicket = client.requestFunctionFactory(getSupportTicket);

    this.listSupportTicketAnswers = client.requestFunctionFactory(
      listSupportTicketAnswers
    );

    this.answerSupportTicket =
      client.requestFunctionFactory(answerSupportTicket);

    this.closeSupportTicket = client.requestFunctionFactory(closeSupportTicket);

    this.listTicketCategories =
      client.requestFunctionFactory(listTicketCategories);

    this.getAllowedFileTypes =
      client.requestFunctionFactory(getAllowedFileTypes);

    this.uploadFile = client.requestFunctionFactory(uploadFile);

    this.getFile = client.requestFunctionFactory(getFile);

    this.deleteFile = client.requestFunctionFactory(deleteFile);

    this.getFileDetails = client.requestFunctionFactory(getFileDetails);

    this.getAccountVisitorStatistics = client.requestFunctionFactory(
      getAccountVisitorStatistics
    );

    this.getAccountStatistics =
      client.requestFunctionFactory(getAccountStatistics);

    this.getPhoneVerificationCode = client.requestFunctionFactory(
      getPhoneVerificationCode
    );

    this.getNavigation = client.requestFunctionFactory(getNavigation);

    this.getNavigationMeta = client.requestFunctionFactory(getNavigationMeta);

    this.search = client.requestFunctionFactory(search);

    this.getDomainOverview = client.requestFunctionFactory(getDomainOverview);

    this.getDnsOverview = client.requestFunctionFactory(getDnsOverview);

    this.getAccountIpAddresses = client.requestFunctionFactory(
      getAccountIpAddresses
    );

    this.updateDnsRecords = client.requestFunctionFactory(updateDnsRecords);

    this.getFlag = client.requestFunctionFactory(getFlag);

    this.changeAccountPassword = client.requestFunctionFactory(
      changeAccountPassword
    );

    this.changeCustomerPassword = client.requestFunctionFactory(
      changeCustomerPassword
    );

    this.initMfaAction = client.requestFunctionFactory(initMfaAction);

    this.confirmMfa = client.requestFunctionFactory(confirmMfa);

    this.getMfaStatus = client.requestFunctionFactory(getMfaStatus);

    this.resetRecoveryCodes = client.requestFunctionFactory(resetRecoveryCodes);

    this.deleteMfa = client.requestFunctionFactory(deleteMfa);

    this.getMfaSecret = client.requestFunctionFactory(getMfaSecret);

    this.verifyToken = client.requestFunctionFactory(verifyToken);

    this.signToken = client.requestFunctionFactory(signToken);

    this.getPublicKey = client.requestFunctionFactory(getPublicKey);

    this.getIsShowFeedback = client.requestFunctionFactory(getIsShowFeedback);

    this.createFeedback = client.requestFunctionFactory(createFeedback);

    this.accountListBlockedBots = client.requestFunctionFactory(
      accountListBlockedBots
    );

    this.accountSetBlockedBots = client.requestFunctionFactory(
      accountSetBlockedBots
    );

    this.accountListDefaultBlockedBots = client.requestFunctionFactory(
      accountListDefaultBlockedBots
    );

    this.listPublicToplevelDomains = client.requestFunctionFactory(
      listPublicToplevelDomains
    );
  }
}

/**
 * ====================================
 * API
 * ====================================
 */

import { createGetApiOperationResource } from "@mittwald/flow-lib/dist/resources/ApiOperationResource/createGetApiOperationResource";

export const mittwaldApiV1 = {
  listApplicationTokens: {
    getResource: createGetApiOperationResource(
      listApplicationTokens,
      MittwaldApiV1Client.getInstance().listApplicationTokens
    ),

    request: MittwaldApiV1Client.getInstance().listApplicationTokens,
    descriptor: listApplicationTokens,
  },

  createApplicationToken: {
    getResource: createGetApiOperationResource(
      createApplicationToken,
      MittwaldApiV1Client.getInstance().createApplicationToken
    ),

    request: MittwaldApiV1Client.getInstance().createApplicationToken,
    descriptor: createApplicationToken,
  },

  getAccessToken: {
    getResource: createGetApiOperationResource(
      getAccessToken,
      MittwaldApiV1Client.getInstance().getAccessToken
    ),

    request: MittwaldApiV1Client.getInstance().getAccessToken,
    descriptor: getAccessToken,
  },

  deleteApplicationToken: {
    getResource: createGetApiOperationResource(
      deleteApplicationToken,
      MittwaldApiV1Client.getInstance().deleteApplicationToken
    ),

    request: MittwaldApiV1Client.getInstance().deleteApplicationToken,
    descriptor: deleteApplicationToken,
  },

  getUserName: {
    getResource: createGetApiOperationResource(
      getUserName,
      MittwaldApiV1Client.getInstance().getUserName
    ),

    request: MittwaldApiV1Client.getInstance().getUserName,
    descriptor: getUserName,
  },

  getAccount: {
    getResource: createGetApiOperationResource(
      getAccount,
      MittwaldApiV1Client.getInstance().getAccount
    ),

    request: MittwaldApiV1Client.getInstance().getAccount,
    descriptor: getAccount,
  },

  updateAccount: {
    getResource: createGetApiOperationResource(
      updateAccount,
      MittwaldApiV1Client.getInstance().updateAccount
    ),

    request: MittwaldApiV1Client.getInstance().updateAccount,
    descriptor: updateAccount,
  },

  getNotifications: {
    getResource: createGetApiOperationResource(
      getNotifications,
      MittwaldApiV1Client.getInstance().getNotifications
    ),

    request: MittwaldApiV1Client.getInstance().getNotifications,
    descriptor: getNotifications,
  },

  deleteNotifications: {
    getResource: createGetApiOperationResource(
      deleteNotifications,
      MittwaldApiV1Client.getInstance().deleteNotifications
    ),

    request: MittwaldApiV1Client.getInstance().deleteNotifications,
    descriptor: deleteNotifications,
  },

  getReseller: {
    getResource: createGetApiOperationResource(
      getReseller,
      MittwaldApiV1Client.getInstance().getReseller
    ),

    request: MittwaldApiV1Client.getInstance().getReseller,
    descriptor: getReseller,
  },

  listDatabaseTypes: {
    getResource: createGetApiOperationResource(
      listDatabaseTypes,
      MittwaldApiV1Client.getInstance().listDatabaseTypes
    ),

    request: MittwaldApiV1Client.getInstance().listDatabaseTypes,
    descriptor: listDatabaseTypes,
  },

  listDomainsByAccount: {
    getResource: createGetApiOperationResource(
      listDomainsByAccount,
      MittwaldApiV1Client.getInstance().listDomainsByAccount
    ),

    request: MittwaldApiV1Client.getInstance().listDomainsByAccount,
    descriptor: listDomainsByAccount,
  },

  registerNewDomain: {
    getResource: createGetApiOperationResource(
      registerNewDomain,
      MittwaldApiV1Client.getInstance().registerNewDomain
    ),

    request: MittwaldApiV1Client.getInstance().registerNewDomain,
    descriptor: registerNewDomain,
  },

  domainProxyList: {
    getResource: createGetApiOperationResource(
      domainProxyList,
      MittwaldApiV1Client.getInstance().domainProxyList
    ),

    request: MittwaldApiV1Client.getInstance().domainProxyList,
    descriptor: domainProxyList,
  },

  deleteDomain: {
    getResource: createGetApiOperationResource(
      deleteDomain,
      MittwaldApiV1Client.getInstance().deleteDomain
    ),

    request: MittwaldApiV1Client.getInstance().deleteDomain,
    descriptor: deleteDomain,
  },

  getDomainAuthCode: {
    getResource: createGetApiOperationResource(
      getDomainAuthCode,
      MittwaldApiV1Client.getInstance().getDomainAuthCode
    ),

    request: MittwaldApiV1Client.getInstance().getDomainAuthCode,
    descriptor: getDomainAuthCode,
  },

  listSubdomainsByDomain: {
    getResource: createGetApiOperationResource(
      listSubdomainsByDomain,
      MittwaldApiV1Client.getInstance().listSubdomainsByDomain
    ),

    request: MittwaldApiV1Client.getInstance().listSubdomainsByDomain,
    descriptor: listSubdomainsByDomain,
  },

  createSubdomain: {
    getResource: createGetApiOperationResource(
      createSubdomain,
      MittwaldApiV1Client.getInstance().createSubdomain
    ),

    request: MittwaldApiV1Client.getInstance().createSubdomain,
    descriptor: createSubdomain,
  },

  deleteSubdomain: {
    getResource: createGetApiOperationResource(
      deleteSubdomain,
      MittwaldApiV1Client.getInstance().deleteSubdomain
    ),

    request: MittwaldApiV1Client.getInstance().deleteSubdomain,
    descriptor: deleteSubdomain,
  },

  getSubdomain: {
    getResource: createGetApiOperationResource(
      getSubdomain,
      MittwaldApiV1Client.getInstance().getSubdomain
    ),

    request: MittwaldApiV1Client.getInstance().getSubdomain,
    descriptor: getSubdomain,
  },

  listEmailAddressesByAccount: {
    getResource: createGetApiOperationResource(
      listEmailAddressesByAccount,
      MittwaldApiV1Client.getInstance().listEmailAddressesByAccount
    ),

    request: MittwaldApiV1Client.getInstance().listEmailAddressesByAccount,
    descriptor: listEmailAddressesByAccount,
  },

  listSoftwares: {
    getResource: createGetApiOperationResource(
      listSoftwares,
      MittwaldApiV1Client.getInstance().listSoftwares
    ),

    request: MittwaldApiV1Client.getInstance().listSoftwares,
    descriptor: listSoftwares,
  },

  listSoftwareInstallationsByAccount: {
    getResource: createGetApiOperationResource(
      listSoftwareInstallationsByAccount,
      MittwaldApiV1Client.getInstance().listSoftwareInstallationsByAccount
    ),

    request:
      MittwaldApiV1Client.getInstance().listSoftwareInstallationsByAccount,
    descriptor: listSoftwareInstallationsByAccount,
  },

  updatePhp: {
    getResource: createGetApiOperationResource(
      updatePhp,
      MittwaldApiV1Client.getInstance().updatePhp
    ),

    request: MittwaldApiV1Client.getInstance().updatePhp,
    descriptor: updatePhp,
  },

  getSoftwareInstallation: {
    getResource: createGetApiOperationResource(
      getSoftwareInstallation,
      MittwaldApiV1Client.getInstance().getSoftwareInstallation
    ),

    request: MittwaldApiV1Client.getInstance().getSoftwareInstallation,
    descriptor: getSoftwareInstallation,
  },

  listSoftwareInstallationExtensions: {
    getResource: createGetApiOperationResource(
      listSoftwareInstallationExtensions,
      MittwaldApiV1Client.getInstance().listSoftwareInstallationExtensions
    ),

    request:
      MittwaldApiV1Client.getInstance().listSoftwareInstallationExtensions,
    descriptor: listSoftwareInstallationExtensions,
  },

  getCurrentCustomer: {
    getResource: createGetApiOperationResource(
      getCurrentCustomer,
      MittwaldApiV1Client.getInstance().getCurrentCustomer
    ),

    request: MittwaldApiV1Client.getInstance().getCurrentCustomer,
    descriptor: getCurrentCustomer,
  },

  getOwnCustomer: {
    getResource: createGetApiOperationResource(
      getOwnCustomer,
      MittwaldApiV1Client.getInstance().getOwnCustomer
    ),

    request: MittwaldApiV1Client.getInstance().getOwnCustomer,
    descriptor: getOwnCustomer,
  },

  getCustomer: {
    getResource: createGetApiOperationResource(
      getCustomer,
      MittwaldApiV1Client.getInstance().getCustomer
    ),

    request: MittwaldApiV1Client.getInstance().getCustomer,
    descriptor: getCustomer,
  },

  getCustomerContractPartner: {
    getResource: createGetApiOperationResource(
      getCustomerContractPartner,
      MittwaldApiV1Client.getInstance().getCustomerContractPartner
    ),

    request: MittwaldApiV1Client.getInstance().getCustomerContractPartner,
    descriptor: getCustomerContractPartner,
  },

  updateCustomerContractPartner: {
    getResource: createGetApiOperationResource(
      updateCustomerContractPartner,
      MittwaldApiV1Client.getInstance().updateCustomerContractPartner
    ),

    request: MittwaldApiV1Client.getInstance().updateCustomerContractPartner,
    descriptor: updateCustomerContractPartner,
  },

  getCustomerContactPerson: {
    getResource: createGetApiOperationResource(
      getCustomerContactPerson,
      MittwaldApiV1Client.getInstance().getCustomerContactPerson
    ),

    request: MittwaldApiV1Client.getInstance().getCustomerContactPerson,
    descriptor: getCustomerContactPerson,
  },

  updateCustomerContactPerson: {
    getResource: createGetApiOperationResource(
      updateCustomerContactPerson,
      MittwaldApiV1Client.getInstance().updateCustomerContactPerson
    ),

    request: MittwaldApiV1Client.getInstance().updateCustomerContactPerson,
    descriptor: updateCustomerContactPerson,
  },

  getCustomerPaymentSettings: {
    getResource: createGetApiOperationResource(
      getCustomerPaymentSettings,
      MittwaldApiV1Client.getInstance().getCustomerPaymentSettings
    ),

    request: MittwaldApiV1Client.getInstance().getCustomerPaymentSettings,
    descriptor: getCustomerPaymentSettings,
  },

  updateCustomerPaymentSettings: {
    getResource: createGetApiOperationResource(
      updateCustomerPaymentSettings,
      MittwaldApiV1Client.getInstance().updateCustomerPaymentSettings
    ),

    request: MittwaldApiV1Client.getInstance().updateCustomerPaymentSettings,
    descriptor: updateCustomerPaymentSettings,
  },

  getCustomerBillingRecipient: {
    getResource: createGetApiOperationResource(
      getCustomerBillingRecipient,
      MittwaldApiV1Client.getInstance().getCustomerBillingRecipient
    ),

    request: MittwaldApiV1Client.getInstance().getCustomerBillingRecipient,
    descriptor: getCustomerBillingRecipient,
  },

  updateCustomerBillingRecipient: {
    getResource: createGetApiOperationResource(
      updateCustomerBillingRecipient,
      MittwaldApiV1Client.getInstance().updateCustomerBillingRecipient
    ),

    request: MittwaldApiV1Client.getInstance().updateCustomerBillingRecipient,
    descriptor: updateCustomerBillingRecipient,
  },

  resetCustomerBillingRecipient: {
    getResource: createGetApiOperationResource(
      resetCustomerBillingRecipient,
      MittwaldApiV1Client.getInstance().resetCustomerBillingRecipient
    ),

    request: MittwaldApiV1Client.getInstance().resetCustomerBillingRecipient,
    descriptor: resetCustomerBillingRecipient,
  },

  getCustomerBillingSettings: {
    getResource: createGetApiOperationResource(
      getCustomerBillingSettings,
      MittwaldApiV1Client.getInstance().getCustomerBillingSettings
    ),

    request: MittwaldApiV1Client.getInstance().getCustomerBillingSettings,
    descriptor: getCustomerBillingSettings,
  },

  updateCustomerBillingSettings: {
    getResource: createGetApiOperationResource(
      updateCustomerBillingSettings,
      MittwaldApiV1Client.getInstance().updateCustomerBillingSettings
    ),

    request: MittwaldApiV1Client.getInstance().updateCustomerBillingSettings,
    descriptor: updateCustomerBillingSettings,
  },

  listInvoicesByCustomer: {
    getResource: createGetApiOperationResource(
      listInvoicesByCustomer,
      MittwaldApiV1Client.getInstance().listInvoicesByCustomer
    ),

    request: MittwaldApiV1Client.getInstance().listInvoicesByCustomer,
    descriptor: listInvoicesByCustomer,
  },

  listAccountsByCustomer: {
    getResource: createGetApiOperationResource(
      listAccountsByCustomer,
      MittwaldApiV1Client.getInstance().listAccountsByCustomer
    ),

    request: MittwaldApiV1Client.getInstance().listAccountsByCustomer,
    descriptor: listAccountsByCustomer,
  },

  getBenefitDetails: {
    getResource: createGetApiOperationResource(
      getBenefitDetails,
      MittwaldApiV1Client.getInstance().getBenefitDetails
    ),

    request: MittwaldApiV1Client.getInstance().getBenefitDetails,
    descriptor: getBenefitDetails,
  },

  listContractsByCustomer: {
    getResource: createGetApiOperationResource(
      listContractsByCustomer,
      MittwaldApiV1Client.getInstance().listContractsByCustomer
    ),

    request: MittwaldApiV1Client.getInstance().listContractsByCustomer,
    descriptor: listContractsByCustomer,
  },

  listCancelledContractsByCustomer: {
    getResource: createGetApiOperationResource(
      listCancelledContractsByCustomer,
      MittwaldApiV1Client.getInstance().listCancelledContractsByCustomer
    ),

    request: MittwaldApiV1Client.getInstance().listCancelledContractsByCustomer,
    descriptor: listCancelledContractsByCustomer,
  },

  getAvContractStatus: {
    getResource: createGetApiOperationResource(
      getAvContractStatus,
      MittwaldApiV1Client.getInstance().getAvContractStatus
    ),

    request: MittwaldApiV1Client.getInstance().getAvContractStatus,
    descriptor: getAvContractStatus,
  },

  getCustomerSettings: {
    getResource: createGetApiOperationResource(
      getCustomerSettings,
      MittwaldApiV1Client.getInstance().getCustomerSettings
    ),

    request: MittwaldApiV1Client.getInstance().getCustomerSettings,
    descriptor: getCustomerSettings,
  },

  setCustomerSettings: {
    getResource: createGetApiOperationResource(
      setCustomerSettings,
      MittwaldApiV1Client.getInstance().setCustomerSettings
    ),

    request: MittwaldApiV1Client.getInstance().setCustomerSettings,
    descriptor: setCustomerSettings,
  },

  getInvoice: {
    getResource: createGetApiOperationResource(
      getInvoice,
      MittwaldApiV1Client.getInstance().getInvoice
    ),

    request: MittwaldApiV1Client.getInstance().getInvoice,
    descriptor: getInvoice,
  },

  getPaymentReceipts: {
    getResource: createGetApiOperationResource(
      getPaymentReceipts,
      MittwaldApiV1Client.getInstance().getPaymentReceipts
    ),

    request: MittwaldApiV1Client.getInstance().getPaymentReceipts,
    descriptor: getPaymentReceipts,
  },

  requestQuote: {
    getResource: createGetApiOperationResource(
      requestQuote,
      MittwaldApiV1Client.getInstance().requestQuote
    ),

    request: MittwaldApiV1Client.getInstance().requestQuote,
    descriptor: requestQuote,
  },

  orderPreUpgradeCheck: {
    getResource: createGetApiOperationResource(
      orderPreUpgradeCheck,
      MittwaldApiV1Client.getInstance().orderPreUpgradeCheck
    ),

    request: MittwaldApiV1Client.getInstance().orderPreUpgradeCheck,
    descriptor: orderPreUpgradeCheck,
  },

  orderPartnerProgram: {
    getResource: createGetApiOperationResource(
      orderPartnerProgram,
      MittwaldApiV1Client.getInstance().orderPartnerProgram
    ),

    request: MittwaldApiV1Client.getInstance().orderPartnerProgram,
    descriptor: orderPartnerProgram,
  },

  orderPartnerBox: {
    getResource: createGetApiOperationResource(
      orderPartnerBox,
      MittwaldApiV1Client.getInstance().orderPartnerBox
    ),

    request: MittwaldApiV1Client.getInstance().orderPartnerBox,
    descriptor: orderPartnerBox,
  },

  listArticles: {
    getResource: createGetApiOperationResource(
      listArticles,
      MittwaldApiV1Client.getInstance().listArticles
    ),

    request: MittwaldApiV1Client.getInstance().listArticles,
    descriptor: listArticles,
  },

  getArticle: {
    getResource: createGetApiOperationResource(
      getArticle,
      MittwaldApiV1Client.getInstance().getArticle
    ),

    request: MittwaldApiV1Client.getInstance().getArticle,
    descriptor: getArticle,
  },

  getCrossSellingOptions: {
    getResource: createGetApiOperationResource(
      getCrossSellingOptions,
      MittwaldApiV1Client.getInstance().getCrossSellingOptions
    ),

    request: MittwaldApiV1Client.getInstance().getCrossSellingOptions,
    descriptor: getCrossSellingOptions,
  },

  getArticleUpgrades: {
    getResource: createGetApiOperationResource(
      getArticleUpgrades,
      MittwaldApiV1Client.getInstance().getArticleUpgrades
    ),

    request: MittwaldApiV1Client.getInstance().getArticleUpgrades,
    descriptor: getArticleUpgrades,
  },

  createCart: {
    getResource: createGetApiOperationResource(
      createCart,
      MittwaldApiV1Client.getInstance().createCart
    ),

    request: MittwaldApiV1Client.getInstance().createCart,
    descriptor: createCart,
  },

  getCart: {
    getResource: createGetApiOperationResource(
      getCart,
      MittwaldApiV1Client.getInstance().getCart
    ),

    request: MittwaldApiV1Client.getInstance().getCart,
    descriptor: getCart,
  },

  updateCart: {
    getResource: createGetApiOperationResource(
      updateCart,
      MittwaldApiV1Client.getInstance().updateCart
    ),

    request: MittwaldApiV1Client.getInstance().updateCart,
    descriptor: updateCart,
  },

  createCartFromTemplate: {
    getResource: createGetApiOperationResource(
      createCartFromTemplate,
      MittwaldApiV1Client.getInstance().createCartFromTemplate
    ),

    request: MittwaldApiV1Client.getInstance().createCartFromTemplate,
    descriptor: createCartFromTemplate,
  },

  deleteCart: {
    getResource: createGetApiOperationResource(
      deleteCart,
      MittwaldApiV1Client.getInstance().deleteCart
    ),

    request: MittwaldApiV1Client.getInstance().deleteCart,
    descriptor: deleteCart,
  },

  addItemToCart: {
    getResource: createGetApiOperationResource(
      addItemToCart,
      MittwaldApiV1Client.getInstance().addItemToCart
    ),

    request: MittwaldApiV1Client.getInstance().addItemToCart,
    descriptor: addItemToCart,
  },

  deleteItemFromCart: {
    getResource: createGetApiOperationResource(
      deleteItemFromCart,
      MittwaldApiV1Client.getInstance().deleteItemFromCart
    ),

    request: MittwaldApiV1Client.getInstance().deleteItemFromCart,
    descriptor: deleteItemFromCart,
  },

  addDomainToCart: {
    getResource: createGetApiOperationResource(
      addDomainToCart,
      MittwaldApiV1Client.getInstance().addDomainToCart
    ),

    request: MittwaldApiV1Client.getInstance().addDomainToCart,
    descriptor: addDomainToCart,
  },

  checkoutOrder: {
    getResource: createGetApiOperationResource(
      checkoutOrder,
      MittwaldApiV1Client.getInstance().checkoutOrder
    ),

    request: MittwaldApiV1Client.getInstance().checkoutOrder,
    descriptor: checkoutOrder,
  },

  createQuoteFromCart: {
    getResource: createGetApiOperationResource(
      createQuoteFromCart,
      MittwaldApiV1Client.getInstance().createQuoteFromCart
    ),

    request: MittwaldApiV1Client.getInstance().createQuoteFromCart,
    descriptor: createQuoteFromCart,
  },

  shareCart: {
    getResource: createGetApiOperationResource(
      shareCart,
      MittwaldApiV1Client.getInstance().shareCart
    ),

    request: MittwaldApiV1Client.getInstance().shareCart,
    descriptor: shareCart,
  },

  recommendCart: {
    getResource: createGetApiOperationResource(
      recommendCart,
      MittwaldApiV1Client.getInstance().recommendCart
    ),

    request: MittwaldApiV1Client.getInstance().recommendCart,
    descriptor: recommendCart,
  },

  verifyRecommendCart: {
    getResource: createGetApiOperationResource(
      verifyRecommendCart,
      MittwaldApiV1Client.getInstance().verifyRecommendCart
    ),

    request: MittwaldApiV1Client.getInstance().verifyRecommendCart,
    descriptor: verifyRecommendCart,
  },

  requestSmsVerification: {
    getResource: createGetApiOperationResource(
      requestSmsVerification,
      MittwaldApiV1Client.getInstance().requestSmsVerification
    ),

    request: MittwaldApiV1Client.getInstance().requestSmsVerification,
    descriptor: requestSmsVerification,
  },

  confirmSmsVerification: {
    getResource: createGetApiOperationResource(
      confirmSmsVerification,
      MittwaldApiV1Client.getInstance().confirmSmsVerification
    ),

    request: MittwaldApiV1Client.getInstance().confirmSmsVerification,
    descriptor: confirmSmsVerification,
  },

  checkDomainAvailability: {
    getResource: createGetApiOperationResource(
      checkDomainAvailability,
      MittwaldApiV1Client.getInstance().checkDomainAvailability
    ),

    request: MittwaldApiV1Client.getInstance().checkDomainAvailability,
    descriptor: checkDomainAvailability,
  },

  listToplevelDomains: {
    getResource: createGetApiOperationResource(
      listToplevelDomains,
      MittwaldApiV1Client.getInstance().listToplevelDomains
    ),

    request: MittwaldApiV1Client.getInstance().listToplevelDomains,
    descriptor: listToplevelDomains,
  },

  getToplevelDomain: {
    getResource: createGetApiOperationResource(
      getToplevelDomain,
      MittwaldApiV1Client.getInstance().getToplevelDomain
    ),

    request: MittwaldApiV1Client.getInstance().getToplevelDomain,
    descriptor: getToplevelDomain,
  },

  getPromotionCode: {
    getResource: createGetApiOperationResource(
      getPromotionCode,
      MittwaldApiV1Client.getInstance().getPromotionCode
    ),

    request: MittwaldApiV1Client.getInstance().getPromotionCode,
    descriptor: getPromotionCode,
  },

  verifyPromotionCode: {
    getResource: createGetApiOperationResource(
      verifyPromotionCode,
      MittwaldApiV1Client.getInstance().verifyPromotionCode
    ),

    request: MittwaldApiV1Client.getInstance().verifyPromotionCode,
    descriptor: verifyPromotionCode,
  },

  listGuestOperatingSystems: {
    getResource: createGetApiOperationResource(
      listGuestOperatingSystems,
      MittwaldApiV1Client.getInstance().listGuestOperatingSystems
    ),

    request: MittwaldApiV1Client.getInstance().listGuestOperatingSystems,
    descriptor: listGuestOperatingSystems,
  },

  convertBankDataToSepa: {
    getResource: createGetApiOperationResource(
      convertBankDataToSepa,
      MittwaldApiV1Client.getInstance().convertBankDataToSepa
    ),

    request: MittwaldApiV1Client.getInstance().convertBankDataToSepa,
    descriptor: convertBankDataToSepa,
  },

  listWebhooks: {
    getResource: createGetApiOperationResource(
      listWebhooks,
      MittwaldApiV1Client.getInstance().listWebhooks
    ),

    request: MittwaldApiV1Client.getInstance().listWebhooks,
    descriptor: listWebhooks,
  },

  createWebhook: {
    getResource: createGetApiOperationResource(
      createWebhook,
      MittwaldApiV1Client.getInstance().createWebhook
    ),

    request: MittwaldApiV1Client.getInstance().createWebhook,
    descriptor: createWebhook,
  },

  getWebhook: {
    getResource: createGetApiOperationResource(
      getWebhook,
      MittwaldApiV1Client.getInstance().getWebhook
    ),

    request: MittwaldApiV1Client.getInstance().getWebhook,
    descriptor: getWebhook,
  },

  updateWebhook: {
    getResource: createGetApiOperationResource(
      updateWebhook,
      MittwaldApiV1Client.getInstance().updateWebhook
    ),

    request: MittwaldApiV1Client.getInstance().updateWebhook,
    descriptor: updateWebhook,
  },

  deleteWebhook: {
    getResource: createGetApiOperationResource(
      deleteWebhook,
      MittwaldApiV1Client.getInstance().deleteWebhook
    ),

    request: MittwaldApiV1Client.getInstance().deleteWebhook,
    descriptor: deleteWebhook,
  },

  cancelContract: {
    getResource: createGetApiOperationResource(
      cancelContract,
      MittwaldApiV1Client.getInstance().cancelContract
    ),

    request: MittwaldApiV1Client.getInstance().cancelContract,
    descriptor: cancelContract,
  },

  resendCancellationConfirmation: {
    getResource: createGetApiOperationResource(
      resendCancellationConfirmation,
      MittwaldApiV1Client.getInstance().resendCancellationConfirmation
    ),

    request: MittwaldApiV1Client.getInstance().resendCancellationConfirmation,
    descriptor: resendCancellationConfirmation,
  },

  getGdprpdFs: {
    getResource: createGetApiOperationResource(
      getGdprpdFs,
      MittwaldApiV1Client.getInstance().getGdprpdFs
    ),

    request: MittwaldApiV1Client.getInstance().getGdprpdFs,
    descriptor: getGdprpdFs,
  },

  uploadGdprpdf: {
    getResource: createGetApiOperationResource(
      uploadGdprpdf,
      MittwaldApiV1Client.getInstance().uploadGdprpdf
    ),

    request: MittwaldApiV1Client.getInstance().uploadGdprpdf,
    descriptor: uploadGdprpdf,
  },

  getGdprpdf: {
    getResource: createGetApiOperationResource(
      getGdprpdf,
      MittwaldApiV1Client.getInstance().getGdprpdf
    ),

    request: MittwaldApiV1Client.getInstance().getGdprpdf,
    descriptor: getGdprpdf,
  },

  deleteGdprpdf: {
    getResource: createGetApiOperationResource(
      deleteGdprpdf,
      MittwaldApiV1Client.getInstance().deleteGdprpdf
    ),

    request: MittwaldApiV1Client.getInstance().deleteGdprpdf,
    descriptor: deleteGdprpdf,
  },

  downloadGdprpdf: {
    getResource: createGetApiOperationResource(
      downloadGdprpdf,
      MittwaldApiV1Client.getInstance().downloadGdprpdf
    ),

    request: MittwaldApiV1Client.getInstance().downloadGdprpdf,
    descriptor: downloadGdprpdf,
  },

  getGdprContractPresets: {
    getResource: createGetApiOperationResource(
      getGdprContractPresets,
      MittwaldApiV1Client.getInstance().getGdprContractPresets
    ),

    request: MittwaldApiV1Client.getInstance().getGdprContractPresets,
    descriptor: getGdprContractPresets,
  },

  createGdprContractPresets: {
    getResource: createGetApiOperationResource(
      createGdprContractPresets,
      MittwaldApiV1Client.getInstance().createGdprContractPresets
    ),

    request: MittwaldApiV1Client.getInstance().createGdprContractPresets,
    descriptor: createGdprContractPresets,
  },

  getGdprContractPreset: {
    getResource: createGetApiOperationResource(
      getGdprContractPreset,
      MittwaldApiV1Client.getInstance().getGdprContractPreset
    ),

    request: MittwaldApiV1Client.getInstance().getGdprContractPreset,
    descriptor: getGdprContractPreset,
  },

  getGdprContracts: {
    getResource: createGetApiOperationResource(
      getGdprContracts,
      MittwaldApiV1Client.getInstance().getGdprContracts
    ),

    request: MittwaldApiV1Client.getInstance().getGdprContracts,
    descriptor: getGdprContracts,
  },

  createGdprContract: {
    getResource: createGetApiOperationResource(
      createGdprContract,
      MittwaldApiV1Client.getInstance().createGdprContract
    ),

    request: MittwaldApiV1Client.getInstance().createGdprContract,
    descriptor: createGdprContract,
  },

  getGdprContract: {
    getResource: createGetApiOperationResource(
      getGdprContract,
      MittwaldApiV1Client.getInstance().getGdprContract
    ),

    request: MittwaldApiV1Client.getInstance().getGdprContract,
    descriptor: getGdprContract,
  },

  deleteGdprContract: {
    getResource: createGetApiOperationResource(
      deleteGdprContract,
      MittwaldApiV1Client.getInstance().deleteGdprContract
    ),

    request: MittwaldApiV1Client.getInstance().deleteGdprContract,
    descriptor: deleteGdprContract,
  },

  createGdprContractPdf: {
    getResource: createGetApiOperationResource(
      createGdprContractPdf,
      MittwaldApiV1Client.getInstance().createGdprContractPdf
    ),

    request: MittwaldApiV1Client.getInstance().createGdprContractPdf,
    descriptor: createGdprContractPdf,
  },

  sendGdprContractMail: {
    getResource: createGetApiOperationResource(
      sendGdprContractMail,
      MittwaldApiV1Client.getInstance().sendGdprContractMail
    ),

    request: MittwaldApiV1Client.getInstance().sendGdprContractMail,
    descriptor: sendGdprContractMail,
  },

  acceptGdprContract: {
    getResource: createGetApiOperationResource(
      acceptGdprContract,
      MittwaldApiV1Client.getInstance().acceptGdprContract
    ),

    request: MittwaldApiV1Client.getInstance().acceptGdprContract,
    descriptor: acceptGdprContract,
  },

  getGdprContacts: {
    getResource: createGetApiOperationResource(
      getGdprContacts,
      MittwaldApiV1Client.getInstance().getGdprContacts
    ),

    request: MittwaldApiV1Client.getInstance().getGdprContacts,
    descriptor: getGdprContacts,
  },

  createGdprContact: {
    getResource: createGetApiOperationResource(
      createGdprContact,
      MittwaldApiV1Client.getInstance().createGdprContact
    ),

    request: MittwaldApiV1Client.getInstance().createGdprContact,
    descriptor: createGdprContact,
  },

  getGdprContact: {
    getResource: createGetApiOperationResource(
      getGdprContact,
      MittwaldApiV1Client.getInstance().getGdprContact
    ),

    request: MittwaldApiV1Client.getInstance().getGdprContact,
    descriptor: getGdprContact,
  },

  getGdprToms: {
    getResource: createGetApiOperationResource(
      getGdprToms,
      MittwaldApiV1Client.getInstance().getGdprToms
    ),

    request: MittwaldApiV1Client.getInstance().getGdprToms,
    descriptor: getGdprToms,
  },

  createGdprTom: {
    getResource: createGetApiOperationResource(
      createGdprTom,
      MittwaldApiV1Client.getInstance().createGdprTom
    ),

    request: MittwaldApiV1Client.getInstance().createGdprTom,
    descriptor: createGdprTom,
  },

  getGdprTom: {
    getResource: createGetApiOperationResource(
      getGdprTom,
      MittwaldApiV1Client.getInstance().getGdprTom
    ),

    request: MittwaldApiV1Client.getInstance().getGdprTom,
    descriptor: getGdprTom,
  },

  listSupportTickets: {
    getResource: createGetApiOperationResource(
      listSupportTickets,
      MittwaldApiV1Client.getInstance().listSupportTickets
    ),

    request: MittwaldApiV1Client.getInstance().listSupportTickets,
    descriptor: listSupportTickets,
  },

  createSupportTicket: {
    getResource: createGetApiOperationResource(
      createSupportTicket,
      MittwaldApiV1Client.getInstance().createSupportTicket
    ),

    request: MittwaldApiV1Client.getInstance().createSupportTicket,
    descriptor: createSupportTicket,
  },

  getSupportTicket: {
    getResource: createGetApiOperationResource(
      getSupportTicket,
      MittwaldApiV1Client.getInstance().getSupportTicket
    ),

    request: MittwaldApiV1Client.getInstance().getSupportTicket,
    descriptor: getSupportTicket,
  },

  listSupportTicketAnswers: {
    getResource: createGetApiOperationResource(
      listSupportTicketAnswers,
      MittwaldApiV1Client.getInstance().listSupportTicketAnswers
    ),

    request: MittwaldApiV1Client.getInstance().listSupportTicketAnswers,
    descriptor: listSupportTicketAnswers,
  },

  answerSupportTicket: {
    getResource: createGetApiOperationResource(
      answerSupportTicket,
      MittwaldApiV1Client.getInstance().answerSupportTicket
    ),

    request: MittwaldApiV1Client.getInstance().answerSupportTicket,
    descriptor: answerSupportTicket,
  },

  closeSupportTicket: {
    getResource: createGetApiOperationResource(
      closeSupportTicket,
      MittwaldApiV1Client.getInstance().closeSupportTicket
    ),

    request: MittwaldApiV1Client.getInstance().closeSupportTicket,
    descriptor: closeSupportTicket,
  },

  listTicketCategories: {
    getResource: createGetApiOperationResource(
      listTicketCategories,
      MittwaldApiV1Client.getInstance().listTicketCategories
    ),

    request: MittwaldApiV1Client.getInstance().listTicketCategories,
    descriptor: listTicketCategories,
  },

  getAllowedFileTypes: {
    getResource: createGetApiOperationResource(
      getAllowedFileTypes,
      MittwaldApiV1Client.getInstance().getAllowedFileTypes
    ),

    request: MittwaldApiV1Client.getInstance().getAllowedFileTypes,
    descriptor: getAllowedFileTypes,
  },

  uploadFile: {
    getResource: createGetApiOperationResource(
      uploadFile,
      MittwaldApiV1Client.getInstance().uploadFile
    ),

    request: MittwaldApiV1Client.getInstance().uploadFile,
    descriptor: uploadFile,
  },

  getFile: {
    getResource: createGetApiOperationResource(
      getFile,
      MittwaldApiV1Client.getInstance().getFile
    ),

    request: MittwaldApiV1Client.getInstance().getFile,
    descriptor: getFile,
  },

  deleteFile: {
    getResource: createGetApiOperationResource(
      deleteFile,
      MittwaldApiV1Client.getInstance().deleteFile
    ),

    request: MittwaldApiV1Client.getInstance().deleteFile,
    descriptor: deleteFile,
  },

  getFileDetails: {
    getResource: createGetApiOperationResource(
      getFileDetails,
      MittwaldApiV1Client.getInstance().getFileDetails
    ),

    request: MittwaldApiV1Client.getInstance().getFileDetails,
    descriptor: getFileDetails,
  },

  getAccountVisitorStatistics: {
    getResource: createGetApiOperationResource(
      getAccountVisitorStatistics,
      MittwaldApiV1Client.getInstance().getAccountVisitorStatistics
    ),

    request: MittwaldApiV1Client.getInstance().getAccountVisitorStatistics,
    descriptor: getAccountVisitorStatistics,
  },

  getAccountStatistics: {
    getResource: createGetApiOperationResource(
      getAccountStatistics,
      MittwaldApiV1Client.getInstance().getAccountStatistics
    ),

    request: MittwaldApiV1Client.getInstance().getAccountStatistics,
    descriptor: getAccountStatistics,
  },

  getPhoneVerificationCode: {
    getResource: createGetApiOperationResource(
      getPhoneVerificationCode,
      MittwaldApiV1Client.getInstance().getPhoneVerificationCode
    ),

    request: MittwaldApiV1Client.getInstance().getPhoneVerificationCode,
    descriptor: getPhoneVerificationCode,
  },

  getNavigation: {
    getResource: createGetApiOperationResource(
      getNavigation,
      MittwaldApiV1Client.getInstance().getNavigation
    ),

    request: MittwaldApiV1Client.getInstance().getNavigation,
    descriptor: getNavigation,
  },

  getNavigationMeta: {
    getResource: createGetApiOperationResource(
      getNavigationMeta,
      MittwaldApiV1Client.getInstance().getNavigationMeta
    ),

    request: MittwaldApiV1Client.getInstance().getNavigationMeta,
    descriptor: getNavigationMeta,
  },

  search: {
    getResource: createGetApiOperationResource(
      search,
      MittwaldApiV1Client.getInstance().search
    ),

    request: MittwaldApiV1Client.getInstance().search,
    descriptor: search,
  },

  getDomainOverview: {
    getResource: createGetApiOperationResource(
      getDomainOverview,
      MittwaldApiV1Client.getInstance().getDomainOverview
    ),

    request: MittwaldApiV1Client.getInstance().getDomainOverview,
    descriptor: getDomainOverview,
  },

  getDnsOverview: {
    getResource: createGetApiOperationResource(
      getDnsOverview,
      MittwaldApiV1Client.getInstance().getDnsOverview
    ),

    request: MittwaldApiV1Client.getInstance().getDnsOverview,
    descriptor: getDnsOverview,
  },

  getAccountIpAddresses: {
    getResource: createGetApiOperationResource(
      getAccountIpAddresses,
      MittwaldApiV1Client.getInstance().getAccountIpAddresses
    ),

    request: MittwaldApiV1Client.getInstance().getAccountIpAddresses,
    descriptor: getAccountIpAddresses,
  },

  updateDnsRecords: {
    getResource: createGetApiOperationResource(
      updateDnsRecords,
      MittwaldApiV1Client.getInstance().updateDnsRecords
    ),

    request: MittwaldApiV1Client.getInstance().updateDnsRecords,
    descriptor: updateDnsRecords,
  },

  getFlag: {
    getResource: createGetApiOperationResource(
      getFlag,
      MittwaldApiV1Client.getInstance().getFlag
    ),

    request: MittwaldApiV1Client.getInstance().getFlag,
    descriptor: getFlag,
  },

  changeAccountPassword: {
    getResource: createGetApiOperationResource(
      changeAccountPassword,
      MittwaldApiV1Client.getInstance().changeAccountPassword
    ),

    request: MittwaldApiV1Client.getInstance().changeAccountPassword,
    descriptor: changeAccountPassword,
  },

  changeCustomerPassword: {
    getResource: createGetApiOperationResource(
      changeCustomerPassword,
      MittwaldApiV1Client.getInstance().changeCustomerPassword
    ),

    request: MittwaldApiV1Client.getInstance().changeCustomerPassword,
    descriptor: changeCustomerPassword,
  },

  initMfaAction: {
    getResource: createGetApiOperationResource(
      initMfaAction,
      MittwaldApiV1Client.getInstance().initMfaAction
    ),

    request: MittwaldApiV1Client.getInstance().initMfaAction,
    descriptor: initMfaAction,
  },

  confirmMfa: {
    getResource: createGetApiOperationResource(
      confirmMfa,
      MittwaldApiV1Client.getInstance().confirmMfa
    ),

    request: MittwaldApiV1Client.getInstance().confirmMfa,
    descriptor: confirmMfa,
  },

  getMfaStatus: {
    getResource: createGetApiOperationResource(
      getMfaStatus,
      MittwaldApiV1Client.getInstance().getMfaStatus
    ),

    request: MittwaldApiV1Client.getInstance().getMfaStatus,
    descriptor: getMfaStatus,
  },

  resetRecoveryCodes: {
    getResource: createGetApiOperationResource(
      resetRecoveryCodes,
      MittwaldApiV1Client.getInstance().resetRecoveryCodes
    ),

    request: MittwaldApiV1Client.getInstance().resetRecoveryCodes,
    descriptor: resetRecoveryCodes,
  },

  deleteMfa: {
    getResource: createGetApiOperationResource(
      deleteMfa,
      MittwaldApiV1Client.getInstance().deleteMfa
    ),

    request: MittwaldApiV1Client.getInstance().deleteMfa,
    descriptor: deleteMfa,
  },

  getMfaSecret: {
    getResource: createGetApiOperationResource(
      getMfaSecret,
      MittwaldApiV1Client.getInstance().getMfaSecret
    ),

    request: MittwaldApiV1Client.getInstance().getMfaSecret,
    descriptor: getMfaSecret,
  },

  verifyToken: {
    getResource: createGetApiOperationResource(
      verifyToken,
      MittwaldApiV1Client.getInstance().verifyToken
    ),

    request: MittwaldApiV1Client.getInstance().verifyToken,
    descriptor: verifyToken,
  },

  signToken: {
    getResource: createGetApiOperationResource(
      signToken,
      MittwaldApiV1Client.getInstance().signToken
    ),

    request: MittwaldApiV1Client.getInstance().signToken,
    descriptor: signToken,
  },

  getPublicKey: {
    getResource: createGetApiOperationResource(
      getPublicKey,
      MittwaldApiV1Client.getInstance().getPublicKey
    ),

    request: MittwaldApiV1Client.getInstance().getPublicKey,
    descriptor: getPublicKey,
  },

  getIsShowFeedback: {
    getResource: createGetApiOperationResource(
      getIsShowFeedback,
      MittwaldApiV1Client.getInstance().getIsShowFeedback
    ),

    request: MittwaldApiV1Client.getInstance().getIsShowFeedback,
    descriptor: getIsShowFeedback,
  },

  createFeedback: {
    getResource: createGetApiOperationResource(
      createFeedback,
      MittwaldApiV1Client.getInstance().createFeedback
    ),

    request: MittwaldApiV1Client.getInstance().createFeedback,
    descriptor: createFeedback,
  },

  accountListBlockedBots: {
    getResource: createGetApiOperationResource(
      accountListBlockedBots,
      MittwaldApiV1Client.getInstance().accountListBlockedBots
    ),

    request: MittwaldApiV1Client.getInstance().accountListBlockedBots,
    descriptor: accountListBlockedBots,
  },

  accountSetBlockedBots: {
    getResource: createGetApiOperationResource(
      accountSetBlockedBots,
      MittwaldApiV1Client.getInstance().accountSetBlockedBots
    ),

    request: MittwaldApiV1Client.getInstance().accountSetBlockedBots,
    descriptor: accountSetBlockedBots,
  },

  accountListDefaultBlockedBots: {
    getResource: createGetApiOperationResource(
      accountListDefaultBlockedBots,
      MittwaldApiV1Client.getInstance().accountListDefaultBlockedBots
    ),

    request: MittwaldApiV1Client.getInstance().accountListDefaultBlockedBots,
    descriptor: accountListDefaultBlockedBots,
  },

  listPublicToplevelDomains: {
    getResource: createGetApiOperationResource(
      listPublicToplevelDomains,
      MittwaldApiV1Client.getInstance().listPublicToplevelDomains
    ),

    request: MittwaldApiV1Client.getInstance().listPublicToplevelDomains,
    descriptor: listPublicToplevelDomains,
  },
};
